// @ts-ignore
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppService } from '../app.service';
import { CacheService } from '../cache.service';
import { SnackBarService } from '../snack-bar.service';
import * as moment from 'moment-timezone';
import { BehaviorSubject, interval } from 'rxjs';
import {
  CreateSourceRequest,
  AllStepsFiles,
  CatogarizedPossibleValues,
  CustomIterable,
  Datasource,
  DatasourceSettings,
  Datawarehouse,
  GAInputAttribute,
  GroupId,
  GSCInputAttributes,
  InputAttribute,
  SnapAdsInputAttribute,
  Source,
  Step,
  StepData,
  StepFile,
  StepProceed,
  Table,
  TableNames,
  Token,
  Warehouse,
  UserDetails
} from '../app.model';
import { environment } from '../../environments/environment';
import { buildIqAwareButtons, isIqReturnResult, returnToIq } from '../shared/helpers/iq-setup-context.helper';
import { applyDevWarehouseStepOverrides } from '../shared/helpers/dev-warehouse-steps.helper';
import { ActivatedRoute, Router } from '@angular/router';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { CommonDialogComponent } from '../common-dialog/common-dialog.component';
import { MatLegacyCheckboxChange as MatCheckboxChange } from '@angular/material/legacy-checkbox';
import { get, toLower, includes, split } from 'lodash-es';
import { TrialPlanService } from 'src/app/services/trialplan/trialplan.service';
import { CryptoService } from '../shared/services/crypto/crypto.service';
import { filterDialogResult, trackFreshsalesEvent } from 'src/app/shared/helpers';

const secondsCounter = interval(1000);

@Component({
  selector: 'app-dynamic-steps',
  templateUrl: './dynamic-steps.component.html',
  styleUrls: ['./dynamic-steps.component.scss']
})

export class DynamicStepsComponent implements OnInit {
  @ViewChild('customTable', { static: true }) customTable: ElementRef;
  allSteps: DatasourceSettings;
  thisStep: Step = new Step();
  currentStep = 0;
  currentSelection: { [key: string]: string[] } = {};
  integrationConfig: StepData[];
  dbIntegrationConfigTables: Table[] = [];
  noOfPreLoginSteps: number;
  noOfPostLoginSteps: number;
  oauthFinished = false;
  userId: number;
  disableAmazonRedshiftspecific = false;
  stepProceed: StepProceed = new StepProceed();
  stepLines: string[] = [];
  stepNodes: string[] = [];
  inputAttributes: InputAttribute[] = [];
  sourceId: number;
  warehouseId: number;
  selectedDatasource: Datasource = new Datasource();
  stepsFinishedData: StepData[];
  selectedDatawarehouse: Datawarehouse = new Datawarehouse();
  createSource: Source = new Source();
  createWarehouse: Warehouse = new Warehouse();
  minFields = true;
  names: string[] = [];
  warehouses: Warehouse[] = [];
  warehouseNames: string[] = [];
  sameIntegrationName = false;
  sametableName = false;
  loader = false;
  minFieldsError = '';
  error_message = '';
  datasourceBoolean: boolean;
  displayName = '';
  editSourceBoolean = false;
  adwordLabelTable = 0;
  adwordLabelReport = 0;
  snapchatLabelReport = 0;
  snapchatLabelTable = 0;
  catagoryTitleIndexes = [];
  integrationNameRegex = '^[a-zA-Z0-9]{1}(?!.*__)[a-zA-Z0-9_]{1,}[a-zA-Z0-9]{1}$';
  editWarehouseBoolean: boolean;
  // sdaccounts: SourceAccount[];
  dateDiable = true;
  baseWord: string = this.appService.getBaseWord();
  stepSelectionKeys: string[];
  pivotAlertNotified = false;
  dynamicStep = false;
  addNotifiedAttributes: string[] = [];
  reloadTables: string[] = [];
  accordionStepIndex = 0;
  notifyFieldAddDrop: boolean;
  userInputChanged = false;
  base64EncodedValue: any;
  currentStepFileStoragePaths: StepFile[] = [new StepFile()];
  allStepsFileStoragePaths: AllStepsFiles[] = [new AllStepsFiles()];
  lastStep = false;
  reAddedColumns: string[] = [];
  storedTables: string[] = [];
  allTables: string[] = [];
  addedTables: string[] = [];
  editedTables: string[] = [];
  editedTablesGA: string[] = [];
  canRemoveExcessData = true;
  customTableDataSource = new BehaviorSubject<InputAttribute[]>([]);
  allCustomColumnsFilled = true;
  customTableExists = false;
  newlyAddedAttributes: InputAttribute[] = [];
  gaInputAttributes: GAInputAttribute[] = [];
  gscInputAttributes = new GSCInputAttributes();
  snapchatInputAttributes: SnapAdsInputAttribute[] = [];
  tableNames: TableNames = new TableNames();
  i1: boolean;
  customColumneditableBoolean = true;
  newCustomKeys = [];
  newFileLoaded = false;
  backDisabled = false;
  duplicateTable = false;
  dateOrHistoryCheckbox = false;
  checkboxDisplayIndex: any;
  // editCustomColumnBoolean:boolean;
  pushenagehistorydisable = false;
  maxDate = new Date();
  minDate = new Date();
  minDateFilter = new Date();
  editCheckedDate = false;
  panelOpenState = false;
  prior = this.minDate.setMonth(this.maxDate.getMonth() - 3);
  gscTables = [];
  gscTableLock = false;
  possibleMetrics: GroupId[] = [];
  possibleBreakDowns: GroupId[] = [];
  changeValueRetainer: string;
  disableTest: boolean = false;
  onRadioValueChangedFlag: boolean = false;
  errorMessagePermissionCheck: string;
  documentURL: string;
  documentName: string;
  displayMessage: boolean = false;
  schemaValue: string;
  userDetails: UserDetails
  ifManagedBigQueryWarehouseIsCreated = false;
  order = { Year: 1, Month: 2, Day: 3, Hour: 4 };

  constructor(private appService: AppService, private cacheService: CacheService, private trialPlanService: TrialPlanService, private snackBarService: SnackBarService,
    private route: ActivatedRoute, private dialog: MatDialog, private router: Router, private cryptoService: CryptoService) {
  }

  ngOnInit() {
    const saras_auth_key = this.cacheService.getObject<Token>('saras_auth_key');
    
    if (saras_auth_key) {
      this.userId = saras_auth_key.userId;
      this.appService.getCurrentSubscriptionPlan(this.userId).then((currentPlan: any) => {
        this.ifManagedBigQueryWarehouseIsCreated = toLower(get(currentPlan, 'body.features.dashboard', 'no')) === "yes";
        this.appService.getUser().then((user) => {
          this.userDetails = user;
          this.checkIfManagedWarehouseIsAlreadyCreated()
        });
      })

      const path = (this.route.url['value'][0].path);
      if (path === 'warehouse') {
        this.datasourceBoolean = false;
        this.editWarehouseBoolean = false;
        this.dataWarehouseInit();
        //  this.appService.getUser().then((user) => {
        //   this.mixpanel.track('view add warehouse', user);
        // });
      } else if (path === 'add-source') {
        // this.appService.getUser().then((user) => {
        //   // this.mixpanel.track('view add integration', user);
        // });
        this.datasourceBoolean = true;
        this.dataSourceInit();
      } else if (path === 'edit-integration') {
        //  this.appService.getUser().then((user) => {
        // this.mixpanel.track('view edit integration', user);
        // });
        this.editSourceBoolean = true;
        this.datasourceBoolean = true;
        this.oauthFinished = true;
        this.dataSourceInit();
      } else if (path === 'edit-warehouse') {

        this.datasourceBoolean = false;
        this.editWarehouseBoolean = true;
        this.dataWarehouseInit();
      }

    } else {
      // this.routeToLogin('Login is required to add a Datasource', 'Do you wish to proceed?');
      this.appService.routeToLogin();
    }

  }

  accordionSetStep(index: number) {
    this.accordionStepIndex = index;
  }

  accordionNextStep() {
    this.accordionStepIndex++;
  }

  accordionPrevStep() {
    this.accordionStepIndex--;
  }

  clickFileInput(inputAttribute: InputAttribute) {
    document.getElementById(inputAttribute.name).click();
  }

  uploadFileToApi($event, inputAttribute: InputAttribute): void {
    const inputValue = $event.target
    const file: File = inputValue.files[0];

    this.appService.uploadFile(this.userId, file).then(res => {
      inputAttribute.fileName = inputAttribute.value.replace(/^.*[\\\/]/, '');
    })
  }

  uploadFile($event, inputAttribute: InputAttribute): void {
    this.readFile($event.target, inputAttribute);
  }

  readFile(inputValue: any, inputAttribute: InputAttribute): void {
    const file: File = inputValue.files[0];
    const myReader: FileReader = new FileReader();
    myReader.readAsDataURL(file);
    myReader.onloadend = (e) => {
      inputAttribute.fileName = inputAttribute.value.replace(/^.*[\\\/]/, '');
      this.base64EncodedValue = myReader.result;
      this.storeFilePaths(inputAttribute);
      this.onFileChange(inputAttribute, this.base64EncodedValue);
    };
  }

  storeFilePaths(inputAttribute: InputAttribute) {
    if (typeof this.allStepsFileStoragePaths[this.currentStep] === 'undefined') {
      this.allStepsFileStoragePaths[this.currentStep] = {
        files: [{
          fileId: inputAttribute.name,
          filePath: inputAttribute.fileName
        }]
      };
    } else {
      let fileFound = false;
      this.allStepsFileStoragePaths[this.currentStep].files.forEach(eachFile => {
        if (eachFile.fileId === inputAttribute.name) {
          fileFound = true;
          eachFile.filePath = inputAttribute.fileName;
        }
      });

      if (!fileFound) {
        this.allStepsFileStoragePaths[this.currentStep].files.push({
          fileId: inputAttribute.name,
          filePath: inputAttribute.fileName
        });
      }
    }
  }

  onFileChange(inputAttribute: InputAttribute, base64Value) {
    this.userInputChanged = true;
    this.currentSelection[this.selectionKey(inputAttribute)] = [base64Value];
  }

  dataSourceInit() {
    // :name param is datasourceType for both add/editand :integrationId param exists only for edit
    const dataSourceType = (this.route.params['value']['name']);
    const integrationId = (this.route.params['value']['integrationId']);
    if (this.editSourceBoolean) {
      this.appService.fetchIntegrationConfig(integrationId, this.userId).then((source) => {
        this.appService.fetchIntegrationTables(this.sourceId, this.userId).then((tablesName) => {
          const tables = tablesName.tables;
          this.dbIntegrationConfigTables = tables;
          tables.forEach(table => {
            this.storedTables.push(table.name);
          });
          this.integrationConfig = source.settings.config;
          this.getDataSource(dataSourceType);
        });
      });
      this.sourceId = integrationId;
    } else {
      this.integrationConfig = [];
      this.getDataSource(dataSourceType);
    }

    this.appService.getIntegrationNames(this.userId).then((names) => {
      this.names = names;
    });
  }

  isSingleElement(array: InputAttribute[]): boolean {
    return array != null && array.length === 1;
  }

  checkIfManagedWarehouseIsAlreadyCreated(){

    this.appService.getEnabledWarehouseList(this.userId).then((warehouses) => {
      warehouses.forEach(warehouse => {
        if (warehouse.status === 'ENABLED' && warehouse.name.toLowerCase() == `Raw_${this.userDetails.company.name}_${this.userDetails.company.companyId}_${environment.stage}`.toLowerCase()) {
          this.ifManagedBigQueryWarehouseIsCreated = true;
        }
      })
    });

  }


  isCustomSelect(element: InputAttribute): boolean {
    return element.type === 'CUSTOM_SELECT';
  }

  validationSuccess(value: string) {
    const regex = new RegExp(this.integrationNameRegex);
    return (regex.exec(value));
  }

  getDataSource(dataSourceType) {

    this.appService.getDataSource(dataSourceType).then((data) => {
      this.selectedDatasource = data;
      this.displayName = this.selectedDatasource.displayName;
      this.pushenagehistorydisable = this.selectedDatasource.type === 'PUSHENGAGE';
      this.allSteps = data.settings;
      this.noOfPreLoginSteps = this.allSteps.preAuthSteps.length;
      this.noOfPostLoginSteps = this.allSteps.postAuthSteps.length;
      this.assignNodesAndLines();
      this.stepsFinishedData = [];
      this.changeStep();

    }).catch(error => {
      console.error('Error getting data source:', error);
      this.loader = false;
    });

  }

  dataWarehouseInit() {
    const dataWarehouseId = (this.route.params['value']['name']);
    if (this.editWarehouseBoolean) {
      const warehouseId = (this.route.params['value']['warehouseId']);
      this.warehouseId = warehouseId;
      const warehouseConfig = this.appService.fetchWarehouseConfig(warehouseId).then(w => {
        // console.log(warehouse)
        this.integrationConfig = w.settings.config;
      });

      const warehouse = this.appService.getWarehouse(dataWarehouseId).then((apiData) => {
        // Dev-only: serve test's BigQuery steps (see dev-warehouse-steps.helper.ts).
        const data = applyDevWarehouseStepOverrides(apiData, environment.type);
        //this.integrationConfig = [];
        this.selectedDatawarehouse = data;
        this.displayName = this.selectedDatawarehouse.displayName;
        this.allSteps = data.settings;
        this.noOfPreLoginSteps = this.allSteps.preAuthSteps.length;
        this.noOfPostLoginSteps = this.allSteps.postAuthSteps.length;


      });

      Promise.all([warehouse, warehouseConfig]).then(resolve => {//console.log(this.integrationConfig,"Promise.all")
        this.assignNodesAndLines();
        this.stepsFinishedData = [];
        this.changeDataWarehouseStep();

      });

    } else {
      this.appService.getWarehouse(dataWarehouseId).then((apiData) => {
        // Dev-only: serve test's BigQuery steps (see dev-warehouse-steps.helper.ts).
        const data = applyDevWarehouseStepOverrides(apiData, environment.type);
        this.integrationConfig = [];
        this.selectedDatawarehouse = data;
        this.displayName = this.selectedDatawarehouse.displayName;
        this.allSteps = data.settings;
        this.noOfPreLoginSteps = this.allSteps.preAuthSteps.length;
        this.noOfPostLoginSteps = this.allSteps.postAuthSteps.length;
        this.assignNodesAndLines();
        this.stepsFinishedData = [];
        this.changeDataWarehouseStep();
      });

      this.appService.getWarehouses(this.userId).then((warehouses) => {
        this.warehouses = warehouses;
        warehouses.forEach(warehouse => {
          this.names.push(warehouse.name);
        });
        this.checkIfManagedWarehouseIsAlreadyCreated()
      });

    }

  }

  changeDataWarehouseStep() {
    // temporarily hard coded loginType below - back end change not sending loginType in response - detected on 21 - March
    // this.selectedDatawarehouse.loginType = 'OAUTH2';
    if (this.currentStep === this.noOfPreLoginSteps && !this.oauthFinished && this.stepProceed.forward
      && this.selectedDatawarehouse.loginType === 'OAUTH2') {
      const props = this.stepsFinishedData;
      // const attribs = this.cryptoService.base64Encode(JSON.stringify(props)) ;
      console.log(this.warehouseId)
      if (this.warehouseId === undefined) {
        this.warehouseId = 0
      }
      const childWindow = window.open(environment.apiUrl + 'datawarehouse/' + this.selectedDatawarehouse.datawarehouseId + '/'
        + this.userId + '/' + this.warehouseId + '/login', '_blank', 'width=1000,height=500,top:100,left=500');
      this.getIntegrationName(childWindow);
    } else if (!this.editWarehouseBoolean && this.currentStep === this.noOfPreLoginSteps && !this.oauthFinished && this.stepProceed.forward
      && this.selectedDatawarehouse.loginType === 'CUSTOM') {
      this.createWarehouse.userId = this.userId;
      this.createWarehouse.datawarehouseId = this.selectedDatawarehouse.datawarehouseId;
      this.createWarehouse.type = this.selectedDatawarehouse.type;
      this.appService.createWarehouse(this.createWarehouse).then((response) => {
        this.warehouseId = response.warehouseId;
        this.oauthFinished = true;
        this.stepProceed.forward = true;
        this.assignAndChangeStep(false);
        // this.loader = false;
      });
    } else if (this.currentStep === this.noOfPreLoginSteps + this.noOfPostLoginSteps && this.stepProceed.forward) {
      this.appService.saveWarehouseStepsData(this.warehouseId, this.stepsFinishedData).then(() => {
        console.log('saveWarehouseStepsData', this.trialPlanService.isNewTrialGuidanceInProgress);
        console.log('this.trialPlanService.isNewTrialGuidanceInProgress', this.trialPlanService.isNewTrialGuidanceInProgress);
        console.log('this.trialPlanService.isOldActiveUser', this.trialPlanService.isOldActiveUser);
        console.log('onSuccessfulIntegrationNewSubscriptionFlow check', this.trialPlanService.isNewTrialGuidanceInProgress || !this.trialPlanService.isOldActiveUser);
        if (this.trialPlanService.isNewTrialGuidanceInProgress || !this.trialPlanService.isOldActiveUser) {
          this.onSuccessfulIntegrationNewSubscriptionFlow();
        } else {
          this.onSuccessfulIntegration();
        }
        // this.router.navigate(['/datasources-listing']);
        if (environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
          trackFreshsalesEvent('dataWarehouseSelected');
        }

        this.loader = false;
      });
    } else if (this.checkNextStepType() === 'DYNAMIC') {
      this.appService.getWarehouseStepData(this.warehouseId, this.stepsFinishedData).then((response) => {
        if (response.status >= 400) {
          this.oauthFinished = false;
          this.minFields = false;
          try {
            if (response.errors === undefined) {
              this.minFieldsError = response.error.errors[0].message;
            } else {
              this.minFieldsError = response.errors[0].message;
            }

          } catch (e) {

          }
          this.inputAttributes = [];
          this.checkMinAttributes();
          this.changeNodesAndLines();
          this.reloadContent();

          if (this.minFieldsError === '') {
            this.currentSelection = this.integrationConfig[this.currentStep].selection;
          }
          // else {
          //   this.currentSelection = this.integrationConfig[this.currentStep - 1 ].selection;
          // }


          this.loader = false;
        } else {
          if (response.body instanceof Array) {
            this.inputAttributes = this.removeDefaultValueForFile(response.body);
          } else {
            this.inputAttributes = get(response, 'body.inputAttributes') ?? this.inputAttributes;
          }
          const selectionKey = this.selectedDatawarehouse.type + '.input.' + (this.currentStep + 1) + '.';
          if (this.currentSelection[selectionKey + 'sshTunnel'] && this.currentSelection[selectionKey + 'sshTunnel'][0] === 'SSH') {
            this.disableAmazonRedshiftspecific = false;

            this.inputAttributes.forEach(inputAttribute => {
              if (inputAttribute.name.startsWith('remote') && inputAttribute.type !== 'HIDDEN') {
                inputAttribute.required = true;
              }

            });

          } else {
            this.currentStep === 1 && this.selectedDatawarehouse.type === 'AMAZONREDSHIFT' ?
              this.disableAmazonRedshiftspecific = true :
              this.disableAmazonRedshiftspecific = false;

          }


          this.checkMinAttributes();
          this.changeNodesAndLines();
          this.reloadContent();
          this.applyExistingConfig();
          this.loader = false;
        }
      });
    } else if (this.checkNextStepType() === 'STATIC') {
      if (this.currentStep >= this.noOfPreLoginSteps) {
        this.inputAttributes = this.removeDefaultValueForFile(this.allSteps.postAuthSteps
        [this.currentStep - this.noOfPreLoginSteps].attributes);
        this.changeNodesAndLines();
        this.reloadContent();
      } else {

        this.inputAttributes = this.removeDefaultValueForFile(this.allSteps.preAuthSteps[this.currentStep].attributes);
        this.changeNodesAndLines();
        this.reloadContent();
      }
      this.applyExistingConfig();
      this.loader = false;
    }
  }

  changeStep() {
    this.lastStep = false;
    this.dynamicStep = false;
    if (this.currentStep === this.noOfPreLoginSteps && !this.oauthFinished && this.stepProceed.forward
      && this.selectedDatasource.loginType === 'OAUTH2') {
      if (!this.editSourceBoolean) {
        const props = this.stepsFinishedData;
        const attribs = this.cryptoService.base64Encode(JSON.stringify(props));
        const childWindow = window.open(environment.apiUrl + 'datasource/' + this.selectedDatasource.sourceId + '/'
          + this.userId + '/login/?inputattributes=' + encodeURIComponent(attribs), '_blank', 'width=1000,height=500,top:100,left=500');
        this.getIntegrationName(childWindow);
      } else {
        this.oauthFinished = true;
        this.stepProceed.forward = true;
        this.assignAndChangeStep(false);
      }
    } else if (this.currentStep === this.noOfPreLoginSteps && !this.oauthFinished && this.stepProceed.forward
      && this.selectedDatasource.loginType === 'CUSTOM') {
      if (!this.editSourceBoolean) {
        this.createSource.userId = this.userId;
        this.createSource.datasourceId = this.selectedDatasource.sourceId;
        this.createSource.type = this.selectedDatasource.type;
        this.appService.createSource(this.createSource).then((response) => {
          this.sourceId = response.sourceId;
          this.oauthFinished = true;
          this.stepProceed.forward = true;
          this.assignAndChangeStep(false);
        });
      } else {
        this.oauthFinished = true;
        this.stepProceed.forward = true;
        this.assignAndChangeStep(false);
        this.loader = false;
      }
    } else if (this.currentStep === this.noOfPreLoginSteps + this.noOfPostLoginSteps && this.stepProceed.forward) {
      this.applyExistingConfig();
      this.saveSource();
    } else if (this.checkNextStepType() === 'DYNAMIC' || this.checkNextStepType() === 'TABLE_SELECT' || this.checkNextStepType() === 'COLUMN_SELECT') {
      if (this.currentStep === this.noOfPreLoginSteps + this.noOfPostLoginSteps - 1) {
        this.lastStep = true;
      }
      this.dynamicStep = true;
      this.appService.getStepData(this.sourceId, this.stepsFinishedData).then((response) => {// debugger
        if (response.status >= 400) {
          this.oauthFinished = false;
          this.minFields = false;
          this.minFieldsError = response.error.errors[0].message;
          this.inputAttributes = [];
          this.checkMinAttributes();
          this.changeNodesAndLines();
          this.reloadContent();
          this.applyExistingConfig();
          this.loader = false;
        } else {
          this.loader = true;
          if (response.body instanceof Array) {
            this.inputAttributes = this.removeDefaultValueForFile(response.body);
          } else {
            this.inputAttributes = get(response, 'body.inputAttributes') ?? this.inputAttributes;
            if (this.selectedDatasource.type === 'FRESHCHAT') {
              this.inputAttributes.forEach((inputAttribute, index) => {
                if (inputAttribute.name === 'historicalmetrics' || inputAttribute.name === 'instantmetrics') {
                  inputAttribute.ifAddButton = true;
                  inputAttribute.ifRemoveButton = false;

                }
                if (inputAttribute.name === 'historicaltables' || inputAttribute.name === 'instanttables' ||
                  inputAttribute.name === 'historicalmetrics' || inputAttribute.name === 'instantmetrics') {
                  inputAttribute.attrInputIndex = 0;
                }
                // inputAttribute.if = index

              });

            }
          }
          if (this.selectedDatasource.type === 'GSC') {
            this.gscInputAttributes = this.getGSCInputAttributes(this.inputAttributes);
          } else if (this.selectedDatasource.type === 'SNAPCHATADS') {
            this.snapchatLabelReport = this.inputAttributes.findIndex(item => item.label.endsWith('_reports'));
            this.snapchatLabelTable = this.inputAttributes.findIndex(item => ((!item.label.endsWith('_reports'))));

          }
          /*  if (this.selectedDatasource.type === 'ADWORDS' && this.currentStep === 2) {// } || this.currentStep === 3)){
              const customReportInputAttr: InputAttribute = {...this.inputAttributes[0]};
              const tablesPossibleValues = [];
              const reportPossibleValues = [];
              this.inputAttributes[0].possibleValues.forEach((item) => {
                if (item.value.endsWith('_REPORT')) {
                  reportPossibleValues.push(item);
                } else {
                  tablesPossibleValues.push(item);
                }
              });
              this.inputAttributes[0].possibleValues = tablesPossibleValues;
              // customReportInputAttr.name = 'reports';
              //    customReportInputAttr.showSelectAll = false
              customReportInputAttr.label = 'Reports';
              customReportInputAttr.possibleValues = reportPossibleValues;
              this.inputAttributes.push(customReportInputAttr);

            }*/
          if (this.selectedDatasource.type === 'ADWORDS' && this.currentStep === 3) {

            const _tableArranger = [];
            const _reportArranger = [];
            let _attrHolder;

            this.inputAttributes.forEach((item) => {
              if (item.label.endsWith('_REPORT')) {
                _reportArranger.push(item);
              } else if ((!item.label.endsWith('_REPORT') && item.label !== 'ListOfAttributes')) {
                _tableArranger.push(item);
              } else if (item.label === 'ListOfAttributes') {
                _attrHolder = item;

              }
            });
            this.inputAttributes = [..._tableArranger, ..._reportArranger];
            this.inputAttributes.push(_attrHolder);


            this.adwordLabelReport = this.inputAttributes.findIndex(item => item.label.endsWith('_REPORT'));
            this.adwordLabelTable = this.inputAttributes.findIndex(item => ((!item.label.endsWith('_REPORT') && item.label !== 'ListOfAttributes')));
            //   this.adwordLabelFirst =
            // this.adwordLabelReport =
          }

          //  if (this.selectedDatasource.type !== 'ADWORDS') {
          this.inputAttributes.forEach(item => {
            if (item.label === 'Tables' || item.label === 'Table and Reports') {
              // const catagories = []
              const catagoriesList: CatogarizedPossibleValues[] = [];
              item.possibleValues.forEach(ele => {
                const index = catagoriesList.findIndex(e => e.catogery === ele.category); // console.log(this.currentSelection)


                ele['reportEnable'] === true ? ele.disabled = false : ele.disabled = true;


                if (index === -1) {
                  const newCatagory = new CatogarizedPossibleValues();
                  newCatagory.item = [ele];
                  newCatagory.catogery = ele.category;
                  catagoriesList.push(newCatagory);

                } else {
                  catagoriesList[index].item.push(ele);

                }
              });
              item.possibleValues = [];
              this.catagoryTitleIndexes.push(0);
              let length = 0;
              catagoriesList.forEach((element, index) => {
                item.possibleValues = item.possibleValues.concat(element.item);
                if (index !== (catagoriesList.length - 1)) {
                  length += element.item.length;
                  this.catagoryTitleIndexes.push(length);

                }

              });
              // item.possibleValues = []
            }

          });

          //  }


          this.gaInputAttributes = this.getGAInputAttributes(this.inputAttributes);
          if (this.inputAttributes.length > 0) {
            this.checkMinAttributes();
          }
          this.changeNodesAndLines();
          this.reloadContent();
          this.applyExistingConfig();
          this.loader = false;
        }
      });
    } else if (this.checkNextStepType() === 'STATIC') {
      if (this.currentStep >= this.noOfPreLoginSteps) {
        this.inputAttributes = this.removeDefaultValueForFile(this.allSteps.postAuthSteps
        [this.currentStep - this.noOfPreLoginSteps].attributes);
        this.changeNodesAndLines();
        this.reloadContent();
      } else {
        this.inputAttributes = this.removeDefaultValueForFile(this.allSteps.preAuthSteps[this.currentStep].attributes);
        this.ableDisableHistoryOrDate();
        this.changeNodesAndLines();
        this.reloadContent();
      }
      this.gscInputAttributes = new GSCInputAttributes();
      this.applyExistingConfig();
      this.loader = false;
    }
  }// change required both able/disable both

  switchBetweenDateAndHistory(inputAttribute, event) {
    if (event.value === 'date') {
      this.dateDiable = false;

    }

    if (event.value === 'history') {
      this.dateDiable = true;
      if (!this.editSourceBoolean) {
        this.currentSelection[this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' +
          'date'] = [''];
      }


    }
  }

  ableDisableHistoryOrDate() {
    let date = false, history = false;
    this.inputAttributes.forEach((item, index) => {
      if (item.label === 'Date') {
        date = true;
      }
      if (item.label === 'History') {
        history = true;
        this.checkboxDisplayIndex = index;
      }
    });
    if (date && history) {
      this.dateOrHistoryCheckbox = true;

    }
  }

  removeDefaultValueForFile(inputAttributes: InputAttribute[]) {
    inputAttributes.forEach(inputAttribute => {
      if (inputAttribute.type === 'FILE') {
        inputAttribute.value = '';
      }
    });
    return inputAttributes;

  }

  removeExcessData() {
    if (this.canRemoveExcessData) {
      const obj = this.integrationConfig[this.currentStep].selection;
      Object.keys(obj).forEach(property => {
        if (this.stepSelectionKeys.length > 0 && this.stepSelectionKeys.indexOf(property) === -1) {
          delete this.integrationConfig[this.currentStep].selection[property];
        }
      });
    }
  }

  applyExistingConfig() {
    this.stepSelectionKeys = [];//console.log(this.integrationConfig, this.integrationConfig.length > this.currentStep, this.currentStep < this.noOfPreLoginSteps + this.noOfPostLoginSteps)
    if (this.integrationConfig.length > this.currentStep && this.currentStep < this.noOfPreLoginSteps + this.noOfPostLoginSteps) { //console.log("if")
      this.currentSelection = this.integrationConfig[this.currentStep].selection;
      this.inputAttributes.forEach(inputAttribute => {
        const selectionKey = this.selectionKey(inputAttribute);
        this.stepSelectionKeys.push(selectionKey);
        let inputAttrIndex = 0;
        if (inputAttribute.type === 'TEXT' || inputAttribute.type === 'INTEGER' || inputAttribute.type === 'FLOAT'
          || inputAttribute.type === 'PASSWORD' || inputAttribute.type === 'EMAIL' || inputAttribute.type === 'DATEPICKER') {
          inputAttribute.value = this.currentSelection[selectionKey][0];
          if (inputAttribute.name === 'date' && inputAttribute.value !== '') {
            this.editCheckedDate = true;
          }
        } else if (inputAttribute.type === 'CHECKBOX') {
          let possibleValueIndex = 0;
          inputAttribute.possibleValues.forEach((cValue) => {
            if (typeof this.currentSelection[selectionKey] !== 'undefined') {

              cValue.selected = this.currentSelection[selectionKey].indexOf(cValue.value) !== -1;
              if (this.selectedDatasource.type === 'YAHOOGEMINI' && cValue.selected) {
                cValue.yahoogeminiDim.forEach(gemini => {
                  if (!(inputAttribute.possibleValues.find(g => g.group === gemini))) {

                    const newGroup = new GroupId();
                    newGroup.value = gemini;
                    newGroup.group = gemini;
                    newGroup.fullLoadSupported = false;
                    newGroup.selected = false;
                    newGroup.yahoogeminiAdd = true;
                    inputAttribute.possibleValues.push(newGroup);

                  }
                  const index = this.currentSelection[selectionKey].indexOf(gemini);
                  if (index !== -1) {
                    this.currentSelection[selectionKey].splice(index, 1);
                  }
                });

              }
            }
            possibleValueIndex++;
          });

          if (this.isPivot(inputAttribute)) {
            const childSelectionKey = this.selectionKey(inputAttribute.childAttribute[0]);
            if (typeof this.currentSelection[childSelectionKey] !== 'undefined') {
              this.stepSelectionKeys.push(childSelectionKey);
              inputAttribute.childAttribute[0].value = this.currentSelection[childSelectionKey][0];
              this.pivotColumnSelectionStatus(inputAttribute.childAttribute[0], inputAttribute);
              this.markChildAttributeError(inputAttribute, selectionKey);
            }
          }
          if (this.selectedDatasource.type === 'SNAPCHATADS' && this.editSourceBoolean && this.currentStep === 3) {
            this.checkFilter(inputAttribute);
            this.canRemoveExcessData = false;
          }

          // inputAttribute.showSelectAll is false for Adwords and true for rest.
          // We are using inputAttribute.showSelectAll to detect Adwords
          if (!inputAttribute.showSelectAll) {
            this.enableOrDisableColumn(inputAttribute);
          }
        } else if (inputAttribute.type === 'CUSTOM_SELECT') {
          inputAttribute.selectedList = this.currentSelection[selectionKey];
        } else if (inputAttribute.type === 'RADIO') {
          if (typeof this.currentSelection[selectionKey] !== 'undefined') {
            if (this.currentSelection[selectionKey].length) {
              inputAttribute.value = this.currentSelection[selectionKey][0];
            }
          }
        } else if (inputAttribute.type === 'FILE') {
          this.applyFilesExistingConfig(inputAttribute);
        } else if (inputAttribute.type === 'DROPDOWN') {
          inputAttribute.value = this.currentSelection[selectionKey] ? this.currentSelection[selectionKey][0] : inputAttribute.value;
          if (inputAttribute.multiselect) {
            //@ts-ignore
            inputAttribute.value = this.currentSelection[this.selectionKey(inputAttribute)]
          }

        } else if (inputAttribute.type === 'CUSTOM_TABLE') {
          this.customTableExists = true;
          this.canRemoveExcessData = false;
          inputAttribute.childAttribute = this.addNewlyAddedCustomColumns(inputAttribute.childAttribute);
          const existingConfigs_Of_Table = Object.keys(this.currentSelection);
          this.i1 = false;
          inputAttribute.childAttribute.forEach((custom_column, i) => {
            if (existingConfigs_Of_Table[(i * 3)] == null) {
              this.i1 = true;
              this.newCustomKeys.push(i);
              // this.alterCustomColumn(inputAttribute,custom_column,existingConfigs_Of_Table,i)
            } else {
              const custom_Name = existingConfigs_Of_Table[(i * 3)];
              const custom_Column_Alias = existingConfigs_Of_Table[1 + i * 3];
              const custom_Column_UserDefined = existingConfigs_Of_Table[2 + i * 3];
              custom_column.customColumnName = this.currentSelection[custom_Name][0];
              custom_column.customColumnAlias = this.currentSelection[custom_Column_Alias][0];
              custom_column.customColumnUserDefined = this.currentSelection[custom_Column_UserDefined][0];
            }
            // custom_column.customColumnName = this.currentSelection[this.selectionKey(custom_column) + '.customColumnName'][0];
            // custom_column.customColumnAlias = this.currentSelection[this.selectionKey(custom_column) + '.customColumnAlias'][0];
            // custom_column.customColumnUserDefined = this.currentSelection[this.selectionKey(custom_column)
            // + '.customColumnUserDefined'][0];
          });
          if (this.i1) {
            this.alterCustomColumn(inputAttribute, existingConfigs_Of_Table);
          }
          this.customTableDataSource.next(inputAttribute.childAttribute);
        } else if (inputAttribute.type === 'EXPANDABLE') {
          this.canRemoveExcessData = false;
          inputAttribute.childAttribute.forEach(childInputAttribute => {
            if (childInputAttribute.type === 'CHECKBOX') {
              const childSelectionKey = this.selectionKey(childInputAttribute); // console.log(childSelectionKey,"childSelectionKey")
              childInputAttribute.possibleValues.forEach((cValue) => {
                if (typeof this.currentSelection[childSelectionKey] !== 'undefined') {
                  // console.log(this.currentSelection[childSelectionKey],cValue,
                  // this.currentSelection[childSelectionKey].indexOf(cValue.value))
                  cValue.selected = this.currentSelection[childSelectionKey].indexOf(cValue.value) !== -1;

                }

              });
            } else if (childInputAttribute.type === 'DROPDOWN') {
              const childSelectionKey = this.selectionKey(childInputAttribute); // console.log(childSelectionKey,"childSelectionKey2")
              if (typeof this.currentSelection[childSelectionKey] !== 'undefined') {
                childInputAttribute.value = this.currentSelection[childSelectionKey][0];
              }


            }
          });
        }
        inputAttrIndex++;
      });
      if (this.editWarehouseBoolean && this.inputAttributes.find(inputAttr => inputAttr.name === 'optionalKeyElements')) {
        this.stepSelectionKeys.push('path')
      }
      this.removeExcessData();
    } else if (this.currentStep < this.noOfPreLoginSteps + this.noOfPostLoginSteps) { //console.log("else")
      this.inputAttributes.forEach(inputAttribute => {

        if (inputAttribute.type === 'CUSTOM_TABLE') {
          this.customTableExists = true;
          this.canRemoveExcessData = false;
          inputAttribute.childAttribute.forEach(custom_column => {
            this.currentSelection[this.selectionKey(custom_column) + '.customColumnName'] = [custom_column.customColumnName];
            this.currentSelection[this.selectionKey(custom_column) + '.customColumnAlias'] = [custom_column.customColumnAlias];
            this.currentSelection[this.selectionKey(custom_column) + '.customColumnUserDefined'] = [custom_column.customColumnUserDefined];
          });
          this.customTableDataSource.next(inputAttribute.childAttribute);
        }
        if (inputAttribute.type === 'CHECKBOX') {
          inputAttribute.childAttribute.forEach(childAttribute => {
            childAttribute.possibleValues.forEach(groupvalue => {
              if (groupvalue.value === 'CountryCriteriaId') {
                groupvalue.disabled = true;
                groupvalue.selected = true;
              }
            });
          });
        }
      });
    }
    this.addHidden(this.inputAttributes);
  }

  getContentForCustomTable(): string {
    return 'New Columns are detected in file. \
    Please click PROCEED button if the changes are intended.';
  }

  getButtonsForCustomTable() {
    return [
      {
        'title': 'PROCEED',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'no-change',
        'class': 'confirm-dialog-proceed'
      },
      {
        'title': 'CANCEL',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'load',
        'class': 'confirm-dialog-later'
      }
    ];
  }

  getValueFromDependentAttr() { //return false
    let returnValue = true;
    if (this.selectedDatawarehouse?.type === 'AMAZONS3' || this.selectedDatawarehouse?.type === 'GCS' || this.selectedDatawarehouse?.type === 'AzureOneLake' || this.selectedDatawarehouse?.type === 'AzureDataLake') {
      // this.inputAttributes.forEach(ip => {
      //   if (ip.name ===)
      // })
      Object.keys(this.currentSelection).forEach(cs => {
        if ((cs === `${this.selectedDatawarehouse.type}.input.3.needTimestampElements` /*|| cs === 'GCS.input.3.needTimestampElements'*/) && this.currentSelection[cs][0] === 'Yes') {
          returnValue = false
        }
      })
      // return
    }
    return returnValue
  }

  alterCustomColumn(inputAttribute: InputAttribute, existingConfigs_Of_Table: string[]) {
    const content = this.getContentForCustomTable();
    const buttons = this.getButtonsForCustomTable();
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: '',
        content: content,
        image: 'warning',
        buttons: buttons
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.backDisabled = true;
      if (result?.type === 'no-change') {
        this.customColumneditableBoolean = false;
        this.newCustomKeys.forEach(value => {
          inputAttribute.childAttribute[value].editCustomColumn = true;

          const newChildAttribute = inputAttribute.childAttribute[value];
          newChildAttribute.possibleValues = this.possibleChildrenValues();
          this.currentSelection[this.selectionKey(newChildAttribute) + '.customColumnName']
            = [inputAttribute.childAttribute[value].customColumnName];
          this.currentSelection[this.selectionKey(newChildAttribute) + '.customColumnAlias']
            = [inputAttribute.childAttribute[value].customColumnAlias];
          this.currentSelection[this.selectionKey(newChildAttribute) + '.customColumnUserDefined']
            = [inputAttribute.childAttribute[value].customColumnUserDefined];

          this.allCustomColumnsFilled = true;
          // this.newlyAddedAttributes.push(newChildAttribute);
          this.customTable.nativeElement.scrollTop = this.customTable.nativeElement.scrollHeight;


        });
        this.customTableDataSource.next(inputAttribute.childAttribute);
      } else if (result?.type === 'load') {
        this.customColumneditableBoolean = true;
        inputAttribute.childAttribute.splice(this.newCustomKeys[0], this.newCustomKeys.length);
      }
    });
  }

  addNewlyAddedCustomColumns(childAttribute: InputAttribute[]) {
    childAttribute = childAttribute.concat(this.newlyAddedAttributes);
    return childAttribute;
  }

  applyFilesExistingConfig(inputAttribute: InputAttribute): void {

    if (typeof this.allStepsFileStoragePaths[this.currentStep] !== 'undefined') {

      this.allStepsFileStoragePaths[this.currentStep].files.forEach(eachFile => {
        if (inputAttribute.name === eachFile.fileId) {
          // inputAttribute.fileName = this.currentSelection[];
          return;
        }
      });

    }

  }

  checkEditWarehouseStepForward() {
    if (this.inputAttributes.length) {

      return !(((this.inputAttributes[0].name === 'database') ||
        (this.inputAttributes[0].name === 'warehouse') ||
        (this.inputAttributes[0].name === 'schema') ||
        (this.inputAttributes[1] && this.inputAttributes[1].name === 'integrationName') || (this.inputAttributes.length === 1 && this.inputAttributes[0].type === 'RADIO')) && (this.editWarehouseBoolean));

    } else {
      return true;
    }




  }

  markChildAttributeError(inputAttribute: InputAttribute, selectionKey) {
    if (typeof this.currentSelection[selectionKey] !== 'undefined') {
      inputAttribute.markChildAttribute = !!this.currentSelection[selectionKey].length;
    } else {
      inputAttribute.markChildAttribute = false;
    }
  }

  saveSource() {
    if (this.editSourceBoolean) {
      this.removeTrashData();
      // const addedTables = this.allTables.filter(tableLabel => this.storedTables.indexOf(tableLabel) < 0);
      const addedTables = this.allTables.filter(tableLabel => {
        let idx = true;
        this.storedTables.forEach(storedTableName => {
          if (storedTableName.endsWith(tableLabel)) {
            idx = false;
          }

        });
        return idx;
      });

      // const removedTables = this.storedTables.filter(tableLabel => this.allTables.indexOf(tableLabel) < 0);
      const removedTables = this.storedTables.filter(tableLabel => {
        let idx = true;
        this.allTables.forEach(allTableName => {
          if (tableLabel.endsWith(allTableName)) {
            idx = false;
          }

        });
        return idx;
      });

      const changedTables = {
        addedTables: addedTables,
        removedTables: removedTables,
        editedTables: this.editedTables
      };
      this.appService.saveEditStepsData(this.sourceId, this.stepsFinishedData, this.reloadTables, this.userId, changedTables).then(() => {
        this.onSuccessfulIntegration();
        this.loader = false;
      });
    } else {
      this.appService.saveStepsData(this.sourceId, this.stepsFinishedData).then(() => {
        this.trialPlanService.activateTrialCompanySubscriptionIfApplicable();
        this.onSuccessfulIntegration();
        this.loader = false;
      });
    }
  }

  removeTrashData() {
    this.allTables = [];
    if (includes(['GOOGLEANALYTICS', 'GA4'], this.selectedDatasource.type)) {
      this.gaInputAttributes.forEach(inputAttribute => {
        this.allTables.push(inputAttribute.table);
      });

    } else {
      this.inputAttributes.forEach(inputAttribute => {
        this.allTables.push(inputAttribute.label);
      });

    }


    this.reloadTables.forEach((reloadTable, index) => {
      let splice = true;
      this.allTables.forEach((tablename) => {
        if (reloadTable.endsWith(tablename)) {
          splice = false;
        }
      });
      if (splice) {
        this.reloadTables.splice(index, 1);
      }
      /* if (this.allTables.indexOf(reloadTable) === -1) {
         this.reloadTables.splice(index, 1);
       }*/
    });
  }

  checkMinAttributes() {
    this.inputAttributes.forEach(inputAttribute => {
      if (inputAttribute.type === 'CHECKBOX' && inputAttribute.childAttribute.length === 0 && inputAttribute.possibleValues.length === 0) {
        this.minFields = false;
        this.minFieldsError = 'There are no accounts associated with this login';
      }
    });
  }

  onSuccessfulIntegration() {
    this.appService.getWarehouses(this.userId).then((warehouses) => {

      const title = 'Integration Successful';
      let content1 = '';
      if (this.editSourceBoolean) {
        content1 = 'You have successfully edited the integration';
      } else {
        content1 = 'You have successfully completed data-source integration';
      }

      let content2 = '';

      if (!warehouses.length) {
        content2 = 'Now proceed with the data warehouse integration';
      } else {
        content2 = ' Now proceed to add more integrations';
      }

      // Opened from iQ: offer "Stay in Daton" + "Continue/Back to iQ" (CommonDialogComponent reverses this list).
      const buttons = buildIqAwareButtons(
        `/${this.baseWord}/integrations-list`,
        [
          {
            title: 'Later',
            meta: `/${this.baseWord}/integrations-list`,
            type: 'redirect',
            class: 'confirm-dialog-later'
          },
          {
            title: 'Proceed',
            meta: `/${this.baseWord}/datasources-listing`,
            type: 'redirect',
            class: 'confirm-dialog-proceed'
          }
        ],
        this.editSourceBoolean
      );
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: title,
          content: content1 + content2,
          image: 'successful',
          buttons
        },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        this.appService.getWarehouseBannerEvent().next(false);
        if (isIqReturnResult(result)) {
          returnToIq(result.meta);
        } else if (result?.type === 'redirect') {
          this.router.navigate([result.meta]);
        }
      });
    });
  }

  onSuccessfulIntegrationNewSubscriptionFlow() {
    console.log('onSuccessfulIntegrationNewSubscriptionFlow entered method');
    this.appService.getWarehouses(this.userId).then((warehouses) => {
      console.log('received warehouse data');
      const title = 'Integration Successful';
      let content1 = '';
      if (this.editSourceBoolean) {
        content1 = 'You have successfully edited the integration';
      } else {
        content1 = 'You have successfully completed data-source integration';
      }

      // Opened from iQ: offer "Stay in Daton" + "Continue/Back to iQ" (CommonDialogComponent reverses this list).
      const buttons = buildIqAwareButtons(
        `/${this.baseWord}/integrations-list`,
        [
          {
            title: 'Later',
            meta: `/${this.baseWord}/integrations-list`,
            type: 'redirect',
            class: 'confirm-dialog-later'
          },
          {
            title: 'Proceed',
            meta: `/${this.baseWord}/datasources-listing`,
            type: 'redirect',
            class: 'confirm-dialog-proceed'
          }
        ],
        this.editSourceBoolean
      );
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: title,
          content: content1,
          image: 'successful',
          buttons
        },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (isIqReturnResult(result)) {
          returnToIq(result.meta);
        } else if (result?.type === 'redirect') {
          console.log('getWarehouseBannerEven destination creation popup before navigate', result);
          this.router.navigate([result.meta]);
          console.log('getWarehouseBannerEven destination creation popup after navigate');
          this.appService.getWarehouseBannerEvent().next(false);
        }
      });
    });
  }

  onSuccessfulPermissionTest() {
    this.appService.getWarehouses(this.userId).then((warehouses) => {

      const title = 'Successfully connected to your warehouse!';
      // Opened from iQ: offer "Stay in Daton" + "Continue/Back to iQ" (CommonDialogComponent reverses this list).
      const buttons = buildIqAwareButtons(
        `/${this.baseWord}/integrations-list`,
        [
          {
            title: "OK",
            meta: "/integrations-list",
            type: "no-change",
            class: "confirm-dialog-later",
          }
        ],
        this.editWarehouseBoolean,
        this.editWarehouseBoolean ? 'no-change' : 'redirect'
      );

      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: title,
          //          content: content1 + content2,
          image: 'successful',
          buttons
        },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (isIqReturnResult(result)) {
          returnToIq(result.meta);
        } else if (result?.type === 'redirect') {
          this.router.navigate([result.meta]);
        }
      });
    });
  }


  checkNextStepType() {
    if (this.currentStep < this.noOfPreLoginSteps + this.noOfPostLoginSteps) {
      if (this.currentStep >= this.noOfPreLoginSteps) {
        return this.allSteps.postAuthSteps[this.currentStep - this.noOfPreLoginSteps].type;
      } else {
        return this.allSteps.preAuthSteps[this.currentStep].type;
      }
    }
  }

  reloadContent() {
    if (this.currentStep < this.noOfPreLoginSteps) {
      this.thisStep = this.allSteps.preAuthSteps[this.currentStep];
      this.documentURL = split(split(get(this.thisStep, 'header'), 'href="')[1] || '', '"')[0];
    } else {
      this.thisStep = this.allSteps.postAuthSteps[this.currentStep - this.noOfPreLoginSteps];
    }
  }

  stepDown(inputAttribute: InputAttribute) {
    if (inputAttribute.value !== null) {
      const value = Math.floor(Number.parseInt(inputAttribute.value, 10));
      const max = inputAttribute.max;
      const min = inputAttribute.min;
      inputAttribute.value = Math.max(Math.min(value, max), min).toString(10);
    }
  }

  // getIntegrationName(child) {
  //   this.oauthFinished = true;
  //   this.stepData.forward = true;
  //   this.assignAndChangeStep(false);
  // }


  getIntegrationName(child) {
    const childWindow = child;
    // console.log(window.opener)
    if (!childWindow) {
    } else {
      let loginSubscription = secondsCounter.subscribe(() => {
        // child window is closed without redirection

        try {
          //  console.log(childWindow);
          if (childWindow.location.href === undefined) {// console.log("hello")
            loginSubscription.unsubscribe();
            this.loader = false;
            this.stepsFinishedData.splice(-1, 1);
            this.currentStep -= 1;
          } else if (childWindow.location.href.includes('/close')) {
            const urlParams = new URLSearchParams(childWindow.location.search);
            if (this.datasourceBoolean) {
              this.sourceId = JSON.parse(urlParams.get('sourceId'));
            } else {
              if (!this.editWarehouseBoolean) {
                this.warehouseId = JSON.parse(urlParams.get('warehouseId'));
              }

            }
            // this.createSource.settings.props = {};
            loginSubscription.unsubscribe();
            childWindow.close();
            this.oauthFinished = true;
            this.stepProceed.forward = true;
            this.assignAndChangeStep(false);
          } else if (childWindow.location.href.includes('/error')) {
            const urlParams = new URLSearchParams(childWindow.location.search);
            // this.createSource.settings.props = {};
            childWindow.close();
            loginSubscription.unsubscribe();
            this.oauthFinished = false;
            this.stepProceed.forward = false;
            this.currentStep -= 1;
            this.stepsFinishedData.splice(-1, 1);
            this.loader = false;
          }
        } catch (e) {
          if (!(e instanceof DOMException)) {
            console.error(e);
          }
        }
      });
    }
  }

  assignAndChangeStep(bool = true) {
    if (bool) {
      this.currentStep = (this.stepProceed.forward) ? this.currentStep + 1 : this.currentStep - 1;
    }
    if (this.datasourceBoolean) {
      this.changeStep();
    } else {
      this.changeDataWarehouseStep();
    }
  }

  assignNodesAndLines() {
    const dataSourceSteps = this.allSteps.preAuthSteps.concat(this.allSteps.postAuthSteps);
    dataSourceSteps.forEach((step, index) => {
      if (index === 0) {
        this.stepLines.push('inactive-line');
        this.stepNodes.push('active-step');
      } else {
        this.stepLines.push('inactive-line');
        this.stepNodes.push('inactive-step');
      }
    });
  }

  /*
  googleSearchconsole(meta:any){
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: '',
        content: 'Looks like you already have an active Google Search Console integration.\n'+
        'Proceeding with the configuration will delete previous integration and creates a new one.',
        image: '',
        buttons: [
          {
            'title': 'CANCEL',
            'meta': meta,
            'type': 'no-change',
            'class': 'confirm-dialog-later'
          },
          {
            'title': 'PROCEED',
            'meta': meta,
            'type': 'change',
            'class': 'confirm-dialog-proceed'
          }
        ]
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.title === 'PROCEED') {
        const props = this.stepsFinishedData;
        const attribs = this.cryptoService.base64Encode(JSON.stringify(props));
        this.appService.revokeGSC(this.selectedDatasource.sourceId,this.userId).then((res)=>{
          console.log("resresres",res)
          const childWindow = window.open(environment.apiUrl + 'datasource/' + this.selectedDatasource.sourceId + '/'
           + this.userId + '/login/?inputattributes=' + encodeURIComponent(attribs), '_blank', 'width=1000,height=500,top:100,left=500');
          this.getIntegrationName(childWindow);
        })

      } else if (result.title === 'CANCEL') {
       const path = '/' + this.baseWord + '/datasources-listing'
        this.router.navigate([path]);
       }
    });
  }*/
  changeNodesAndLines() {

    this.stepLines.forEach((value, index) => {
      if (index < this.currentStep) {
        this.stepLines[index] = 'active-line';
      } else {
        this.stepLines[index] = 'inactive-line';
      }
    });

    this.stepNodes.forEach((value, index) => {
      if (index < this.currentStep) {
        this.stepNodes[index] = 'done-step';
      } else if (index === this.currentStep) {
        this.stepNodes[index] = 'active-step';
      } else {
        this.stepNodes[index] = 'inactive-step';
      }
    });
    this.currentSelection = {};
    this.inputAttributes.forEach((value) => {
      if (value.type === 'TEXT' || value.type === 'INTEGER' || value.type === 'FLOAT' || value.type === 'PASSWORD' || value.type === 'DATEPICKER' || value.type === 'DROPDOWN') {
        let selectionKey = (this.datasourceBoolean) ? this.selectedDatasource.type : this.selectedDatawarehouse.type;
        selectionKey = selectionKey + '.input.' + (this.currentStep + 1) + '.' +
          value.name;
        this.currentSelection[selectionKey] = [value.value];
        if (value.type === 'DATEPICKER') {
          value.description = 'Date(MM/DD/YYYY)';
        }
      }
      if (this.selectedDatawarehouse.type === 'AMAZONREDSHIFT' && this.currentStep === 1 && value.type === 'DROPDOWN') {
        let selectionKey = (this.datasourceBoolean) ? this.selectedDatasource.type : this.selectedDatawarehouse.type;
        selectionKey = selectionKey + '.input.' + (this.currentStep + 1) + '.' +
          value.name;
        this.currentSelection[selectionKey] = [value.value];
      }
    });
  }

  onSubmit() {// console.log(this.currentSelection);
    if (this.allCustomColumnsFilled) {
      if (this.editSourceBoolean) {
        this.integrationConfig[this.currentStep].selection = this.currentSelection;
      } else if (this.datasourceBoolean) {

        if (this.selectedDatasource.type === 'GSC' && this.gscTables.length > 1) {
          const selectionKey = this.gscTables[(this.gscTables.length) - 1];
          this.gscTables.forEach((table, index) => {
            if (index !== (this.gscTables.length - 1)) {
              this.currentSelection[selectionKey].push(table);
            }

          });

        }

        this.integrationConfig[this.currentStep] = {
          stepNumber: this.currentStep + 1,
          selection: this.currentSelection,
          stepType: this.thisStep.type
        };
      } else {
        this.integrationConfig[this.currentStep] = {
          stepNumber: this.currentStep + 1,
          selection: this.currentSelection,
          stepType: this.thisStep.type
        };
      }
      this.dateOrHistoryCheckbox = false;
      this.loader = true;
      this.stepProceed.forward = true;
      this.stepsFinishedData.push({
        stepNumber: this.currentStep + 1,
        selection: this.currentSelection,
        stepType: this.thisStep.type
      }
      );
      this.assignAndChangeStep();
    } else {
      window.alert('Please fill already added columns to create a new column');
    }
    if (this.inputAttributes[0]?.name === 'schema') {
      this.schemaValue = this.inputAttributes[0]?.value;
    }
  }

  onCancel() {
    const meta = (this.editSourceBoolean) ? '/' + this.baseWord + '/integrations-list' : '/' + this.baseWord + '/datasources-listing';
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: '',
        content: 'Are you sure you want to quit the Integration?',
        image: 'warning',
        buttons: [

          {
            'title': 'YES',
            'meta': meta,
            'type': 'change',
            'class': 'confirm-dialog-proceed'
          },
          {
            'title': 'NO',
            'meta': meta,
            'type': 'no-change',
            'class': 'confirm-dialog-later'
          }
        ]
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.type === 'change') {
        this.router.navigate([meta]);
      }
    });
  }

  onBack() {
    // this.customColumneditableBoolean = true;
    if (this.allCustomColumnsFilled) {
      if (this.editSourceBoolean) {
        this.integrationConfig[this.currentStep].selection = this.currentSelection;
      } else {
        this.integrationConfig[this.currentStep] = {
          stepNumber: this.currentStep + 1,
          selection: this.currentSelection,
          stepType: this.thisStep.type
        };
        this.currentSelection = this.integrationConfig[this.currentStep - 1].selection;
      }
      this.loader = true;
      this.minFields = true;
      this.minFieldsError = '';
      this.stepProceed.forward = false;
      this.stepsFinishedData.splice(-1, 1);
      this.assignAndChangeStep();
    } else {
      window.alert('Please fill already added columns to create a new column');
    }
  }

  /*
  This function will check the read write permission of warehouse.
  related Doc : https://docs.sarasanalytics.com/integrations/destinations/bigquery/setup-google-bigquery
  Issue ticket number : #881
  */
  checkPermission() {

    let additionalParms;

    if (this.selectedDatawarehouse.type === 'AMAZONS3') {
      this.inputAttributes.forEach(inputAttr => {
        let key = this.selectionKey(inputAttr)
        if (key.includes('region')) {
          additionalParms = this.currentSelection[key][0]
        }
      })
    } else if (includes(this.selectedDatawarehouse.type, 'Azure')) {
      additionalParms = 'selected'
    } else {
      additionalParms = this.schemaValue
    }

    this.disableTest = false;
    this.loader = true;
    this.appService.checkPermission(this.warehouseId, this.stepsFinishedData, additionalParms).then(() => {
      this.onSuccessfulPermissionTest()
      this.disableTest = true;
      this.onRadioValueChangedFlag = false;
      if (environment.apiUrl === 'https://webapi.sarasanalytics.com/') {
        trackFreshsalesEvent('dataWarehouseSelected');
      }
      //this.appService.getWarehouseBannerEvent().next(false);
      this.loader = false;
    })
      .catch((err) => this.showErrorMessage(err));

  }

  showErrorMessage(error: any) {
    let errorMessage;
    this.loader = false;
    this.documentName = "documentation"
    this.displayMessage = true;
    let defaultErrorMessage = "We couldn't access your warehouse. Please check if you have read & write permissions to the schema selected. For more information, refer to";

    errorMessage = get(error, 'error.errors[0].message', error);

    if (errorMessage === "We couldn't access your Bigquery account. To resolve the error, please add the following permissions in your GCP IAM tab to 210514.iam.gserviceaccount.com and try again. 1.BigQuery Job User, 2.BigQuery Data Owner, For more information, refer to documentation : https://docs.sarasanalytics.com/integrations/destinations/bigquery/setup-google-bigquery") {
      this.errorMessagePermissionCheck = errorMessage.split("documentation : ")[0]
      this.documentURL = "https://docs.sarasanalytics.com/integrations/destinations/bigquery/setup-google-bigquery";
    }

    if (errorMessage === "AMAZONREDSHIFT: Read-Write permission issue") {
      this.errorMessagePermissionCheck = defaultErrorMessage
      this.documentURL = "https://docs.sarasanalytics.com/integrations/destinations/amazon-redshift";
    }

    if (errorMessage === "SNOWFLAKE: Read-Write permission issue") {
      this.errorMessagePermissionCheck = defaultErrorMessage
      this.documentURL = "https://docs.sarasanalytics.com/integrations/destinations/snowflake";
    }

    if (errorMessage === "Oracle: Read-Write permission issue") {
      this.errorMessagePermissionCheck = defaultErrorMessage
      this.documentURL = "https://docs.sarasanalytics.com/integrations/destinations/oracle-autonomous-data-warehouse";
    }

    if (errorMessage === "amazon-s3: Read-Write permission issue") {
      this.errorMessagePermissionCheck = defaultErrorMessage
      this.documentURL = "https://docs.sarasanalytics.com/integrations/destinations/amazon-s3";
    }
  }
  /**
   * This function is written to enable test button for BIGQUERY warehouse to test GCP account permission
   * @returns false for steps 0 and 1 ,
   * @returns case1 : true if test response is success for customer GCP permission check.
   *          case2 : will return true if step number is 2 and 3 and warehouse is BIGQUERY.
   */
  enableTestButtonForPermission() {//debugger
    if (this.inputAttributes.length && (this.selectedDatawarehouse.type === "BIGQUERY" || this.selectedDatawarehouse.type === "GCS" ||
      this.selectedDatawarehouse.type === "AMAZONREDSHIFT" || this.selectedDatawarehouse.type === "AMAZONS3" ||
      this.selectedDatawarehouse.type === "SNOWFLAKE" || includes(this.selectedDatawarehouse.type, 'AzureDataLake')) && this.currentStep === (this.noOfPreLoginSteps + this.noOfPostLoginSteps - 1)) {
      if (this.selectedDatawarehouse.type === "BIGQUERY" && this.onRadioValueChangedFlag === true) {
        return this.disableTest === true ? false : true
      }
      else
        return this.disableTest === true && this.onRadioValueChangedFlag !== true ? false : true
    }
    else if (this.currentStep !== (this.noOfPreLoginSteps + this.noOfPostLoginSteps - 1)) {
      this.displayMessage = false;
      this.disableTest = false;
      return false;
    }
  }

  onAddCustomValue(value: any, inputAttribute: InputAttribute, index) {
    this.userInputChanged = true;
    if (this.selectedDatasource.type === 'FRESHCHAT') {
      const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + this.inputAttributes[index - 1].value + '.' + inputAttribute.name;
      this.currentSelection[selectedKey] = [value.value];

    } else if (!this.currentSelection[this.selectionKey(inputAttribute)]) {
      this.currentSelection[this.selectionKey(inputAttribute)] = [value.value.toString()];
    } else {
      if (this.currentSelection[this.selectionKey(inputAttribute)].length < inputAttribute.max) {
        this.currentSelection[this.selectionKey(inputAttribute)].push(value.value.toString());
      }
    }
  }

  onRemoveCustomValue(value: any, inputAttribute: InputAttribute, index) {
    this.userInputChanged = true;
    if (this.selectedDatasource.type === 'FRESHCHAT') {
      const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + this.inputAttributes[index - 1].value + '.' + inputAttribute.name;
      delete this.currentSelection[selectedKey];

    } else if (!this.currentSelection[this.selectionKey(inputAttribute)]) {
      this.currentSelection[this.selectionKey(inputAttribute)] = [];
    } else {
      this.currentSelection[this.selectionKey(inputAttribute)].filter(item => item !== value.label.toString());
    }
  }


  onTextValueChange(inputAttribute: InputAttribute) {
    this.userInputChanged = true;
    if (inputAttribute.name === 'integrationName') {
      this.sameIntegrationName = false;
      this.names.forEach(name => {
        if (inputAttribute.value.toUpperCase().trim() === name.toUpperCase()) {
          this.sameIntegrationName = true;
          this.snackBarService.open('Integration with name \'' + inputAttribute.value + '\' exists');
        }
      });
    }

    if (this.selectedDatasource.type === 'FRESHCHAT' && (inputAttribute.name === 'historicaltables' ||
      inputAttribute.name === 'instanttables')) {

      this.updateAndValidateFreshChatTableNames(inputAttribute);
      if (inputAttribute.attrInputIndex === 0) {
        this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
      } else {
        this.currentSelection[this.selectionKey(inputAttribute)][inputAttribute.attrInputIndex] = inputAttribute.value;
      }


    } else {

      this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
    }

  }

  updateAndValidateFreshChatTableNames(inputAttribute: InputAttribute) {
    const selectedTable = [];
    this.inputAttributes.forEach(i => {
      if (i.name === 'historicaltables' || i.name === 'instanttables') {
        if (selectedTable.includes(i.value)) {
          i.errorMessage = 'duplicate table name';
          this.sametableName = true;
        } else {
          selectedTable.push(i.value);
          i.errorMessage = '';
          this.sametableName = false;
        }

      }
    });

  }

  onDropDownValueChanged(inputAttribute: InputAttribute, parentAttributeName = '', triggerNotif = true) {
    if (this.selectedDatawarehouse.type === 'AMAZONREDSHIFT' && inputAttribute.value === 'SSH') {
      this.disableAmazonRedshiftspecific = false;
      this.inputAttributes.forEach(i => {
        if (i.name.startsWith('remote') && i.type !== 'HIDDEN') {
          i.required = true;
        }
      });
    } else if (this.selectedDatawarehouse.type === 'AMAZONREDSHIFT' && inputAttribute.value === 'None') {
      const selectionKey = this.selectedDatawarehouse.type + '.input.' + (this.currentStep + 1) + '.';
      this.inputAttributes.forEach(i => {
        if (i.name.startsWith('remote') && i.type !== 'HIDDEN' && i.type !== 'CLIPBOARD') {
          this.currentSelection[selectionKey + i.name] = [''];
          i.value = '';
          i.fileName = '';
          i.required = false;
        }


      });
      this.disableAmazonRedshiftspecific = true;

    }

    if ((this.selectedDatasource.type === 'GOOGLEDRIVEFILE' ||
      this.selectedDatasource.type === 'DROPBOXFILE' ||
      this.selectedDatasource.type === 'AMAZONS3' ||
      this.selectedDatasource.type === 'SFTPFILEINTERFACE' ||
      this.selectedDatasource.type === 'GCSFILE') &&
      (inputAttribute.value === 'TXT' && inputAttribute.label === 'File Type ')) {
      const index = this.inputAttributes.findIndex(i => i.label === 'Delimiters');
      if (index !== -1) {
        this.inputAttributes[index].type = 'DROPDOWN';
      }

    } /*else if ( ( this.selectedDatasource.type === 'GOOGLEDRIVEFILE' ||
                this.selectedDatasource.type === 'DROPBOXFILE' ||
                this.selectedDatasource.type === 'AMAZONS3' ||
                this.selectedDatasource.type === 'SFTPFILEINTERFACE' ||
                this.selectedDatasource.type === 'GCSFILE' ) &&
                ( inputAttribute.value !== 'TXT' && inputAttribute.label === 'File Type ') ) {
      const index = this.inputAttributes.findIndex(inputAttribute => inputAttribute.label === 'Delimiters');
      index !== -1 ? this.inputAttributes[index].type = 'HIDDEN' : '';
    }*/

    if (this.editSourceBoolean &&
      (this.addNotifiedAttributes).indexOf(parentAttributeName) === -1
      && triggerNotif && this.lastStep /*&& (this.reAddedColumns).indexOf(parentAttributeName.value) === -1*/) {

      this.storedTables.some(table => {
        if (inputAttribute.name.includes(table)) {
          this.alertDataDropDropDown(inputAttribute, parentAttributeName);
          this.changeValueRetainer = this.currentSelection[this.selectionKey(inputAttribute)][0];
          return true;
        }


      });
      // this.changeValueRetainer = this.currentSelection[this.selectionKey(inputAttribute)][0];

    }


    this.userInputChanged = true;
    //@ts-ignore
    this.currentSelection[this.selectionKey(inputAttribute)] = (inputAttribute.multiselect) ? inputAttribute.value : [inputAttribute.value];//[inputAttribute.value]; // console.log(this.currentSelection)


  }

  onRadioValueChanged(inputAttribute: InputAttribute) {
    if (inputAttribute.name === 'schema') {
      this.schemaValue = inputAttribute.value
    }

    this.onRadioValueChangedFlag = true;
    this.userInputChanged = true;
    this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
  }

  toggleExpandable(event, inputAttribute: InputAttribute) {

    inputAttribute.selected = !inputAttribute.selected;

  }

  onSelectValueChanged(inputAttribute: InputAttribute, parentAttribute: InputAttribute, event) {
    this.userInputChanged = true;
    if ((inputAttribute.value && this.editSourceBoolean)) {
      // changing the replication field  will overwrite the existing data
      if (this.currentSelection[this.selectionKey(inputAttribute)]) {
        if (!this.pivotAlertNotified) {
          this.alertUserMessage('', 'Changing the replication field  will overwrite the existing data!',
            inputAttribute, parentAttribute);
        } else {
          this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
          this.pivotColumnSelectionStatus(inputAttribute, parentAttribute);
        }
      } else {
        this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
        this.pivotColumnSelectionStatus(inputAttribute, parentAttribute);
      }
    } else if (this.editSourceBoolean) {
      this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
      this.pivotColumnSelectionStatus(inputAttribute, parentAttribute);
    }
    if (!this.editSourceBoolean) {
      this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
      this.pivotColumnSelectionStatus(inputAttribute, parentAttribute);
    }
  }

  alertUserMessage(title, content, inputAttribute: InputAttribute, parentAttribute: InputAttribute) {
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: title,
        content: content,
        image: 'warning',
        buttons: [
          {
            'title': 'CANCEL',
            'meta': '/' + this.baseWord + '/integrations-list',
            'type': 'no-change',
            'class': 'confirm-dialog-later'
          },
          {
            'title': 'PROCEED',
            'meta': '/' + this.baseWord + '/integrations-list',
            'type': 'change',
            'class': 'confirm-dialog-proceed'
          }
        ]
      },
      disableClose: true
    });

    dialogRef.afterClosed().pipe(filterDialogResult<any>()).subscribe(result => {
      this.pivotAlertNotified = true;
      if (result?.type === 'change') {
        this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
        this.pivotColumnSelectionStatus(inputAttribute, parentAttribute);
      } else {
        inputAttribute.value = this.currentSelection[this.selectionKey(inputAttribute)][0];
        this.pivotColumnSelectionStatus(inputAttribute, parentAttribute);
      }
    });
  }

  // require change all caps for pop up buttons

  pivotColumnSelectionStatus(inputAttribute: InputAttribute, parentAttribute: InputAttribute) {
    parentAttribute.possibleValues.forEach(possibleValue => {
      if (inputAttribute.value === possibleValue.value) {
        possibleValue.selected = true;
        possibleValue.disabled = true;
        if (typeof this.currentSelection[this.selectionKey(parentAttribute)] !== 'undefined') {
          if (!this.currentSelection[this.selectionKey(parentAttribute)].includes(possibleValue.value)) {
            this.currentSelection[this.selectionKey(parentAttribute)].push(possibleValue.value);
          }
        } else {
          this.currentSelection[this.selectionKey(parentAttribute)] = [possibleValue.value];
        }
      } else {
        possibleValue.disabled = false;
      }
    });
  }

  onNumberValueChange(inputAttribute: InputAttribute) {
    this.userInputChanged = true;
    this.currentSelection[this.selectionKey(inputAttribute)] = [inputAttribute.value];
  }

  alertDataDropGA(gaInputAttribute: GAInputAttribute, value: GroupId, inputAttribute: InputAttribute) {
    const title = '';
    let content = '';
    let buttons = [];
    content = 'Click RELOAD to drop and reload the data based on selected history. \
    Click LOAD to ignore historic data for the new fields. Data will be populated for these fields from now on';
    buttons = [
      {
        'title': 'CANCEL',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'no-change',
        'class': 'confirm-dialog-later'
      },
      {
        'title': 'LOAD',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'load',
        'class': 'confirm-dialog-proceed'
      },
      {
        'title': 'RELOAD',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'reload',
        'class': 'confirm-dialog-proceed'
      }
    ];

    this.dbIntegrationConfigTables.some(table => {
      if (table.name.endsWith(gaInputAttribute.table)) {
        this.alertDropUserMessageGA(title, content, gaInputAttribute, value, buttons, inputAttribute);
        return true;
      }
    });


  }


  alertDataDropDropDown(inputAttribute: InputAttribute, parentAttributeName: string) {

    const title = '';
    let content = '';
    let buttons = [];
    content = 'Click RELOAD to drop and reload the data based on selected history. \
      Click LOAD to ignore historic data for the new fields. Data will be populated for these fields from now on';
    buttons = [
      {
        'title': 'CANCEL',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'no-change',
        'class': 'confirm-dialog-later'
      },
      {
        'title': 'LOAD',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'load',
        'class': 'confirm-dialog-proceed'
      },
      {
        'title': 'RELOAD',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'reload',
        'class': 'confirm-dialog-proceed'
      }
    ];
    // this.alertDropUserMessage(title, content, inputAttribute, value, buttons, event);

    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: title,
        content: content,
        image: 'warning',
        buttons: buttons
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.pivotAlertNotified = true;
      if (result?.type === 'no-change') {
        inputAttribute.value = this.changeValueRetainer;
        this.onDropDownValueChanged(inputAttribute, parentAttributeName, false);
      } else if (result?.type === 'load') {
        this.editedTablesData(parentAttributeName);
        this.addNotifiedAttributes.push(parentAttributeName);
      } else if (result?.type === 'reload') {
        this.storedTables.forEach(ele => {
          if (/*inputAttribute.label.includes(ele)*/ ele === parentAttributeName) {
            this.reloadTables.push(parentAttributeName);
          }
        });
        this.addNotifiedAttributes.push(parentAttributeName);
        this.editedTablesData(parentAttributeName);
      }


    });

  }

  alertDataDrop(inputAttribute: InputAttribute, value: GroupId, event: MatCheckboxChange) {
    // below two constants can be used in pop up to display which field we are notifying about
    const mainName = inputAttribute.name;
    const subName = value.group;
    const title = '';
    let content = '';
    let buttons = [];
    if (event.checked) {
      content = 'Click RELOAD to drop and reload the data based on selected history. \
      Click LOAD to ignore historic data for the new fields. Data will be populated for these fields from now on';
      buttons = [
        {
          'title': 'CANCEL',
          'meta': '/' + this.baseWord + '/integrations-list',
          'type': 'no-change',
          'class': 'confirm-dialog-later'
        },
        {
          'title': 'LOAD',
          'meta': '/' + this.baseWord + '/integrations-list',
          'type': 'load',
          'class': 'confirm-dialog-proceed'
        },
        {
          'title': 'RELOAD',
          'meta': '/' + this.baseWord + '/integrations-list',
          'type': 'reload',
          'class': 'confirm-dialog-proceed'
        }
      ];

      this.dbIntegrationConfigTables.some(table => {
        /* if (table.name === inputAttribute.label) {
           this.alertDropUserMessage(title, content, inputAttribute, value, buttons, event);
           return true;
         } else if (this.selectedDatasource.type === 'AMAZONADS' && table.name.endsWith(inputAttribute.label)) {
           this.alertDropUserMessage(title, content, inputAttribute, value, buttons, event);
           return true;

         }*/
        if (table.name.endsWith(inputAttribute.label)) {
          this.alertDropUserMessage(title, content, inputAttribute, value, buttons, event);
          return true;
        }
      });
    } else {
      this.editedTablesData(inputAttribute.label);
      this.reAddedColumns.push(value.value);
    }
  }


  alertDropUserMessageGA(title: string, content: string, inputAttribute: GAInputAttribute, value: GroupId, buttons,
    inputAttributeType: InputAttribute) {

    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: title,
        content: content,
        image: 'warning',
        buttons: buttons
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.pivotAlertNotified = true;
      if (result?.type === 'no-change') {
        // event.checked = !event.checked;
        // value.selected = !value.selected;
        this.removeGaTableAttributeValues({
          ...value,
          label: value.value
        }, inputAttribute, inputAttributeType, inputAttribute.tableName.value, true);
        //  this.onGaTableAttributeValue(event, inputAttribute,inputAttribute.dimensions,inputAttribute.tableName.value);
      } else if (result?.type === 'load') {
        // this.addNotifiedAttributes.push(inputAttribute.name);
        // this.editedTablesData(inputAttribute.label);
        this.editedTables.push(inputAttribute.table);
        this.editedTablesGA.push(inputAttribute.table);
      } else if (result?.type === 'reload') {
        //  this.addNotifiedAttributes.push(inputAttribute.name);
        this.storedTables.forEach(ele => {
          if (ele.endsWith(inputAttribute.table)) {
            this.reloadTables.push(ele);
          }
        });

        this.editedTablesData(inputAttribute.table, true);

      }

    });

  }

  alertDropUserMessage(title: string, content: string, inputAttribute: InputAttribute, value: GroupId, buttons, event: MatCheckboxChange) {
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: title,
        content: content,
        image: 'warning',
        buttons: buttons
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      this.pivotAlertNotified = true;
      if (result?.type === 'no-change') {
        event.checked = !event.checked;
        value.selected = !value.selected;
        this.onCheckBoxChanged(inputAttribute, value, event, false);
      } else if (result?.type === 'load') {
        this.addNotifiedAttributes.push(inputAttribute.name);
        this.editedTablesData(inputAttribute.label);
      } else if (result?.type === 'reload') {
        this.addNotifiedAttributes.push(inputAttribute.name);
        // this.reloadTables.push(inputAttribute.label);
        this.storedTables.forEach(ele => {
          if (ele.endsWith(inputAttribute.label)) {
            this.reloadTables.push(ele);
          }
        });

        this.editedTablesData(inputAttribute.label);
      }
      // inputAttribute.showSelectAll is false for Adwords and true for rest.
      // We are using inputAttribute.showSelectAll to detect Adwords
      if (!inputAttribute.showSelectAll) {
        this.enableOrDisableColumn(inputAttribute);
      }
    });
  }

  editedTablesData(label: string, GAtable = false) {
    if ((this.editedTables).indexOf(label) === -1) {
      this.editedTables.push(label);
    }
    if (GAtable) {
      this.editedTablesGA.push(label);
    }
  }


  onCheckBoxChanged(inputAttribute: InputAttribute, value: GroupId, event: MatCheckboxChange, triggerNotif = true) {


    this.userInputChanged = true;

    if (this.selectedDatasource.type === 'SNAPCHATADS' && this.currentStep === 3) {
      const tableName = value.value;
      if (value.childAttribute.length > 0) {
        // this.possibleMetrics = value.childAttribute.find(c => c.label === 'Metrics').possibleValues;
        const breakdownInCamp = ['ad', 'adsquad'];
        const breakdownAdAccont = ['campaign'];
        const breakdowns = value.childAttribute.find(c => c.label === 'breakdown');
        if (tableName === 'campaign_reports') {
          breakdowns.possibleValues = breakdowns.possibleValues.filter(p => breakdownInCamp.indexOf(p.value) !== -1);
        } else if (tableName === 'adaccount_reports') {
          breakdowns.possibleValues = breakdowns.possibleValues.filter(p => breakdownAdAccont.indexOf(p.value) !== -1);
        }
      }
    }

    // if (!event.checked && this.editSourceBoolean && (this.dropNotifiedAttributes).indexOf(inputAttribute.name) === -1
    // && triggerNotif && this.notifyFieldAddDrop) {
    //   this.alertDataDrop(inputAttribute, value, event);
    //   this.dropNotifiedAttributes.push(inputAttribute.name);
    // } else if (event.checked && this.editSourceBoolean && (this.addNotifiedAttributes).indexOf(inputAttribute.name) === -1
    // && triggerNotif && this.notifyFieldAddDrop) {
    //   this.alertDataDrop(inputAttribute, value, event);
    //   this.addNotifiedAttributes.push(inputAttribute.name);
    // }

    if (this.editSourceBoolean &&
      (this.addNotifiedAttributes).indexOf(inputAttribute.name) === -1
      && triggerNotif && this.lastStep && (this.reAddedColumns).indexOf(value.value) === -1) {
      this.alertDataDrop(inputAttribute, value, event);
    }
    if (this.selectedDatasource.type === 'YAHOOGEMINI' && value.yahoogeminiDim) {
      value.yahoogeminiDim.forEach(gemini => {
        if (value.selected && !(inputAttribute.possibleValues.find(g => g.group === gemini))) {
          const newGroup = new GroupId();
          newGroup.value = gemini;
          newGroup.group = gemini;
          newGroup.fullLoadSupported = false;
          newGroup.selected = false;
          newGroup.yahoogeminiAdd = true;
          inputAttribute.possibleValues.push(newGroup);

        } else if (!value.selected) {

          const index = inputAttribute.possibleValues
            .findIndex(ele => ele.yahoogeminiAdd && (gemini === ele.value));
          if (index !== -1) {
            inputAttribute.possibleValues.splice(index, 1);
          }

          const index2 = this.currentSelection[selectionKey].findIndex(ele => ele === gemini);
          if (index !== -1) {
            this.currentSelection[selectionKey].splice(index2, 1);
          }

        }
      });
    }
    const selectionKey = this.selectionKey(inputAttribute);

    if (!this.currentSelection[selectionKey]) {
      this.currentSelection[selectionKey] = [];
    }
    if (value.selected) {

      if (value.value === 'metafields' && this.selectedDatasource.type === 'SHOPIFY'
        && !this.currentSelection[selectionKey].includes('id')) {
        this.snackBarService.open('You need to select id before selecting metafields field.');

        setTimeout(() => {
          event.checked = !event.checked;
          value.selected = !value.selected;
          this.onCheckBoxChanged(inputAttribute, value, event, false);
        }, 500);
      }

      this.currentSelection[selectionKey].push(value.value);
      this.pushData(selectionKey, value);
    } else {

      if (value.value === 'id' && this.selectedDatasource.type === 'SHOPIFY'
        && this.currentSelection[selectionKey].includes('metafields')) {
        this.snackBarService.open('You need to unselect metafields before unselecting id field.');
        setTimeout(() => {
          event.checked = !event.checked;
          value.selected = !value.selected;
          this.onCheckBoxChanged(inputAttribute, value, event, false);
        }, 500);
      }

      this.currentSelection[selectionKey].splice(this.currentSelection[selectionKey].indexOf(value.value), 1);
      this.deleteData(selectionKey, value);
    }
    if (this.selectedDatasource.type === 'SNAPCHATADS' && this.currentStep === 3) {
      const possibleVals = inputAttribute.possibleValues.filter(table => table.value === value.value && table.category === 'Reports')[0];
      if (possibleVals !== undefined) {
        possibleVals.childAttribute.filter(c => c.required === true).forEach(childfilter => {
          const filterkey = this.selectedDatasource.type + '.props.' + value.value + '.data.' + childfilter.name;
          if (value.selected) {
            this.currentSelection[filterkey] = [childfilter.value];
          } else {
            delete this.currentSelection[filterkey];
          }
        });
      }
    }
    if (!inputAttribute.showSelectAll) {
      this.enableOrDisableColumn(inputAttribute);
    }

    this.markChildAttributeError(inputAttribute, selectionKey);
  }

  onCheckBoxChangeAll(event, inputAttribute: InputAttribute) {
    const selectionKey = this.selectionKey(inputAttribute);
    let normalFlow = false;
    const zohoPossibleValues = [];
    // removed this latest to avoid showing error class name
    if (typeof this.currentSelection[selectionKey] === 'undefined') {
      this.currentSelection[selectionKey] = [];
    }
    if (this.lastStep && this.editSourceBoolean && this.addNotifiedAttributes.indexOf(inputAttribute.name) === -1) {
      this.dbIntegrationConfigTables.some(table => {
        if (table.name.endsWith(inputAttribute.label)) {

          normalFlow = true;
          if (event.checked && inputAttribute.possibleValues.some(item => item.selected === false)) {
            this.alertDropUserMessageSelectAll(inputAttribute, selectionKey);
          }
          return true;
        }
      });
    }


    if (this.selectedDatasource.type === 'YAHOOGEMINI') {
      inputAttribute.possibleValues.forEach(value => {
        value.yahoogeminiDim.forEach(gemini => {
          if (event.checked && !(inputAttribute.possibleValues.find(g => g.group === gemini))) {

            const newGroup = new GroupId();
            newGroup.value = gemini;
            newGroup.group = gemini;
            newGroup.fullLoadSupported = false;
            newGroup.selected = false;
            newGroup.yahoogeminiAdd = true;
            inputAttribute.possibleValues.push(newGroup);

          } else if (!event.checked) {

            const index = inputAttribute.possibleValues
              .findIndex(ele => ele.yahoogeminiAdd && (gemini === ele.value));
            if (index !== -1) {
              inputAttribute.possibleValues.splice(index, 1);
            }

            const index2 = this.currentSelection[selectionKey].findIndex(ele => ele === gemini);
            if (index !== -1) {
              this.currentSelection[selectionKey].splice(index2, 1);
            }

          }


        });
      });

    }


    // normal flow happens when not last step or if its add integration or if user has already chosen to reload this table earlier
    if (!this.lastStep || !normalFlow || !this.editSourceBoolean) {
      inputAttribute.possibleValues.forEach(possibleValue => {
        if (!(possibleValue.group.endsWith('_NA'))) {
          if (!possibleValue.disabled && (possibleValue.canSelect)) {
            possibleValue.selected = inputAttribute.selected;
          }
          zohoPossibleValues.push(possibleValue);
        }

      });

      if (inputAttribute.selected) {
        if (this.selectedDatasource.type !== 'ADWORDS') {
          this.currentSelection[selectionKey] = [];
        }
        if (this.selectedDatasource.type === 'ZOHOCRM' || this.selectedDatasource.type === 'ZOHODESK') {
          this.currentSelection[selectionKey] =
            this.currentSelection[selectionKey].concat(zohoPossibleValues.map(v => v.value));
        } else {
          let possibleValues = [];
          possibleValues = inputAttribute.possibleValues.filter(v => !(v.disabled) && (v.canSelect)); // console.log(possibleValues)
          this.currentSelection[selectionKey] =
            this.currentSelection[selectionKey].concat(possibleValues.map(v => v.value));
          // if (this.selectedDatasource.type == 'SNAPCHATADS') {
          //   this.checkFilter(inputAttribute);
          // }
        }


      } else {
        this.currentSelection[selectionKey] = [];
      }
      this.markChildAttributeError(inputAttribute, selectionKey);
      if (this.isPivot(inputAttribute)) {
        this.pivotColumnSelectionStatus(inputAttribute.childAttribute[0], inputAttribute);
      }
    }
  }

  createManagedBigQuery() {
    this.createWarehouse.userId = this.userId;
    this.createWarehouse.datawarehouseId = this.selectedDatawarehouse.datawarehouseId;
    this.createWarehouse.type = this.selectedDatawarehouse.type;
    this.appService.createWarehouse(this.createWarehouse).then((response) => {
      // Opened from iQ: offer "Stay in Daton" + "Continue in iQ" (CommonDialogComponent reverses this list).
      const buttons = buildIqAwareButtons(
        `/${this.baseWord}/integrations-list`,
        [
          {
            title: 'Proceed',
            meta: `/${this.baseWord}/integrations-list`,
            type: 'redirect',
            class: 'confirm-dialog-proceed'
          }
        ],
        false
      );
      const dialogRef = this.dialog.open(CommonDialogComponent, {
        data: {
          title: 'Integration Successful',
          content: 'Managed bigquery warehouse has been created.',
          image: 'successful',
          buttons
        },
        disableClose: true
      });

      dialogRef.afterClosed().subscribe(result => {
        if (isIqReturnResult(result)) {
          returnToIq(result.meta);
        } else if (result?.type === 'redirect') {
          this.router.navigate([result.meta]);
        }
      });
    });
  }

  onCheckBoxChangeAllColumsInAllRows(event) {
    this.inputAttributes.forEach((inputAttribute) => {
      inputAttribute.selected = event.checked;
      this.onCheckBoxChangeAll(event, inputAttribute);
    });
  }

  getButtons() {
    return [
      {
        'title': 'CANCEL',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'no-change',
        'class': 'confirm-dialog-later'
      },
      {
        'title': 'LOAD',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'load',
        'class': 'confirm-dialog-proceed'
      },
      {
        'title': 'RELOAD',
        'meta': '/' + this.baseWord + '/integrations-list',
        'type': 'reload',
        'class': 'confirm-dialog-proceed'
      }
    ];
  }

  getContent(): string {
    return 'Click RELOAD to drop and reload the data based on selected history. \
    Click LOAD to ignore historic data for the new fields. Data will be populated for these fields from now on';
  }

  alertDropUserMessageChangeDropDown() {

  }

  alertDropUserMessageSelectAll(inputAttribute: InputAttribute, selectionKey: string) {
    const content = this.getContent();
    const buttons = this.getButtons();
    const dialogRef = this.dialog.open(CommonDialogComponent, {
      data: {
        title: '',
        content: content,
        image: 'warning',
        buttons: buttons
      },
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.type === 'no-change') {
        inputAttribute.selected = !inputAttribute.selected;
      } else if (result?.type === 'load') {
        this.selectAllLoadReload(inputAttribute, selectionKey);
        this.editedTablesData(inputAttribute.label);
      } else if (result?.type === 'reload') {
        // this.reloadTables.push(inputAttribute.label);
        this.storedTables.forEach(ele => {
          if (ele.endsWith(inputAttribute.label)) {
            this.reloadTables.push(ele);
          }
        });
        this.selectAllLoadReload(inputAttribute, selectionKey);
        this.editedTablesData(inputAttribute.label);
      }
    });
  }

  selectAllLoadReload(inputAttribute: InputAttribute, selectionKey: string) {
    this.addNotifiedAttributes.push(inputAttribute.name);
    inputAttribute.possibleValues.forEach(possibleValue => {
      possibleValue.selected = inputAttribute.selected;
    });
    if (inputAttribute.selected) {
      this.currentSelection[selectionKey] = [];
      this.currentSelection[selectionKey] =
        this.currentSelection[selectionKey].concat(inputAttribute.possibleValues.map(v => v.value));
    } else {
      this.currentSelection[selectionKey] = [];
    }
    this.markChildAttributeError(inputAttribute, selectionKey);
    if (this.isPivot(inputAttribute)) {
      this.pivotColumnSelectionStatus(inputAttribute.childAttribute[0], inputAttribute);
    }
  }

  isPivot(inputAttribute: InputAttribute) {
    return inputAttribute.pivot;
  }

  isColumnSelected(inputAttribute: InputAttribute, groupId: GroupId): GroupId {
    const selectedColumns = this.currentSelection[this.selectionKey(inputAttribute)];
    if (selectedColumns && selectedColumns.includes(groupId.value)) {
      groupId.selected = true;
      return groupId;
    } else {
      groupId.selected = false;
      return groupId;
    }
  }

  uniqueDropdown(tableName: string, groupId: GroupId, inputAttribute: InputAttribute, childAttribute: InputAttribute) {
    if (groupId.group === 'view_attribution_window' || groupId.group === 'swipe_up_attribution_window') {
      const viewWindow = inputAttribute.childAttribute.find(v => v.label === 'view_attribution_window');
      const swipeWindow = inputAttribute.childAttribute.find(v => v.label === 'swipe_up_attribution_window');
      if ((viewWindow.value === '7_DAY' && swipeWindow.value === '1_DAY') ||
        (viewWindow.value === '28_DAY' && swipeWindow.value === '1_DAY') ||
        (viewWindow.value === '28_DAY' && swipeWindow.value === '7_DAY')) {
        childAttribute.help = 'This operation is not allowed';
        const res = window.confirm('TThis operation is not allowed');
        if (!res) {
          const selectionKey = this.selectedDatasource.type + '.props.' + tableName + '.data.' + groupId.group;
          this.currentSelection[selectionKey] = [groupId.value];
        } else {
          groupId.value = inputAttribute.childAttribute.find(c => c.label === groupId.group).value;
        }
      }
    } else {
      const selectionKey = this.selectedDatasource.type + '.props.' + tableName + '.data.' + groupId.group;
      if (this.currentSelection[selectionKey] !== undefined) {
        this.currentSelection[selectionKey].push(groupId.value);
      } else {
        this.currentSelection[selectionKey] = [groupId.value];
      }
    }
  }

  checkFilter(inputAttribute: InputAttribute) {
    const selectedTables = this.currentSelection[this.selectionKey(inputAttribute)];
    inputAttribute.possibleValues.filter(item => selectedTables.includes(item.group) && item.category === 'Reports').forEach(table => {
      table.childAttribute.forEach(childAttribute => {
        const tableKey = `${this.selectedDatasource.type}.props.${table.group}.data.${childAttribute.name}`;
        if (childAttribute.label === 'Metrics' || childAttribute.label === 'Dimension Metrics') {
          childAttribute.selectedList = this.currentSelection[tableKey];
        } else {
          if (this.currentSelection[tableKey] && this.currentSelection[tableKey].length > 0) {
            if (childAttribute.name === 'report_dimension') {
              childAttribute.selectedList = this.currentSelection[tableKey];
            } else {
              childAttribute.value = this.currentSelection[tableKey][0];
            }
            childAttribute.selected = true;
          }
        }
      });
    });
  }

  enableOrDisableColumn(newinputAttribute: InputAttribute) {
    this.inputAttributes.forEach(inputAttribute => {
      if (inputAttribute.label === newinputAttribute.label) {
        const excludedSet = [...this.inputAttributes[(this.inputAttributes.length - 1)].childAttribute];
        const allpossiblevalues: GroupId[] = [];
        const tobeChanged: GroupId[] = [];
        const selectedColumns = this.currentSelection[this.selectionKey(inputAttribute)];
        inputAttribute.childAttribute.forEach(childAttribute => {
          childAttribute.possibleValues.forEach(groupvalue => {
            if (groupvalue.value === 'CountryCriteriaId') {
              groupvalue.selected = true;
              if (!selectedColumns.includes(groupvalue.value)) {
                selectedColumns.push(groupvalue.value);
              }
            }
            allpossiblevalues.push(groupvalue);
            if (selectedColumns && selectedColumns.includes(groupvalue.value)) {
              tobeChanged.push(groupvalue);
            }
          });
        });
        // const tobeChagecolumn = tobeChanged.filter(column => column.exclusionFields.length > 0);
        const tobeChagecolumn = tobeChanged.filter((column) => {
          const record = excludedSet.find(ele => ele.name === column.value && ele['exclusionAttributeFields'].length > 0);
          if (record) {
            // @ts-ignore
            column.exclusionFields = record.exclusionAttributeFields;
          }

          return record;
        });
        const tobedisabledColumns: string[] = [];
        tobeChagecolumn.forEach(value => {
          value.exclusionFields.forEach(element => {
            tobedisabledColumns.push(element);
          });
        });
        inputAttribute.childAttribute.forEach(nchildAttribute => {
          nchildAttribute.possibleValues.forEach(value => {
            if (tobedisabledColumns.includes(value.value)) {
              value.selected = false;
              value.disabled = true;
            } else {
              value.disabled = false;
            }
            if (value.value === 'CountryCriteriaId') {
              value.disabled = true;
            }
          });
        });
      }
    });
  }

  atleastOneFromAllSelectedAndAllFilesUploaded() {//debugger
    let checkBoxExists = false;
    let returnValue = true;
    let atleastOneFromAllSelected = true;
    let ifAdwordsAtLeastOne = false;
    let ifExpandable = false;
    let atleastOne_FromAllselected = true;
    this.inputAttributes.forEach(inputAttribute => {
      if (inputAttribute.type === 'CHECKBOX' || inputAttribute.type === 'CHECKBOX_TABLE' || inputAttribute.type === 'CHECKBOX_CARD') {
        checkBoxExists = true;
        let atleastOneSelected = false;
        // inputAttribute.showSelectAll is false for Adwords and true for rest.
        // We are using inputAttribute.showSelectAll to detect Adwords
        if (!inputAttribute.showSelectAll) {
          inputAttribute.childAttribute.forEach(childAttribute => {
            childAttribute.possibleValues.forEach(value => {
              if (value.selected) {
                atleastOneSelected = true;
              }
            });
          });
        } else {
          inputAttribute.possibleValues.forEach(value => {
            if (value.selected) {
              atleastOneSelected = true;
              ifAdwordsAtLeastOne = true;
            }
          });
        }// changes


        // this block to detect and stye if replication field is validated or not

        // this block detects if atleast one checkbox is selected
        if (!atleastOneSelected) {
          atleastOneFromAllSelected = false;
        }
      }

      if (inputAttribute.type === 'EXPANDABLE') {
        ifExpandable = true;
        let atleastOne_selected = false;
        inputAttribute.childAttribute.forEach(childAttribute => {
          atleastOne_selected = false;
          if (childAttribute.type === 'CHECKBOX') {

            childAttribute.possibleValues.forEach(value => {
              if (value.selected) {
                atleastOne_selected = true;
              }
            });

          }


          if (childAttribute.type === 'DROPDOWN' && childAttribute.value === '') {
            atleastOne_FromAllselected = false;

          } else if (childAttribute.type === 'DROPDOWN' && !(childAttribute.value === '')) {
            atleastOne_selected = true;
          }


          if (!atleastOne_selected) {
            atleastOne_FromAllselected = false;
          }

        });


      }


      if (inputAttribute.type === 'FILE' && inputAttribute.required && !inputAttribute.fileName) {
        returnValue = false;
      }
    });

    if (ifExpandable && !atleastOne_FromAllselected) {
      returnValue = false;
    }

    if (checkBoxExists && !atleastOneFromAllSelected) {
      returnValue = false;
    }
    if (ifAdwordsAtLeastOne && this.selectedDatasource.type === 'ADWORDS') {
      returnValue = true;
    }

    // check if table name is valid for gaIntegration
    if (this.gaInputAttributes.length > 0) {
      this.gaInputAttributes.forEach((gaInputAttribute) => {
        const gaTableNameRegex = '^[a-zA-Z0-9]{1}(?!.*__)[a-zA-Z0-9_]{1,}[a-zA-Z0-9]{1}$';
        const regex = new RegExp(gaTableNameRegex);
        const gaTableName = gaInputAttribute.table;
        const regexVal = regex.exec(gaTableName);
        if (gaInputAttribute.table == null || gaInputAttribute.table === '' || regexVal == null) {
          returnValue = false;
        }
      });

    }
    if (this.gscInputAttributes.iterableData && this.gscInputAttributes.iterableData.length > 0) {
      this.gscInputAttributes.iterableData.forEach((gscInputAttribute) => {
        const gaTableNameRegex = '^[a-zA-Z0-9]{1}(?!.*__)[a-zA-Z0-9_]{1,}[a-zA-Z0-9]{1}$';
        const regex = new RegExp(gaTableNameRegex);
        const gaTableName = gscInputAttribute.table;
        const regexVal = regex.exec(gaTableName);
        if (gscInputAttribute.table == null || gscInputAttribute.table === '' || regexVal == null) {
          returnValue = false;
        }
      });

    }
    // if (checkBoxExists) {
    //   return atleastOneFromAllSelected;
    // }
    // return (checkBoxExists) ? (atleastOneFromAllSelected) : true;
    return returnValue;
  }

  /*
    atleastOneFromAllSelectedAndAllFilesUploaded() {
      let checkBoxExists = false;
      let returnValue = true;
      let atleastOneFromAllSelected = true;
      let ifAdwordsAtLeastOne = false;
      this.inputAttributes.forEach(inputAttribute => {
        if (inputAttribute.type === 'CHECKBOX') {
          checkBoxExists = true;
          let atleastOneSelected = false;
          // inputAttribute.showSelectAll is false for Adwords and true for rest.
          // We are using inputAttribute.showSelectAll to detect Adwords
          if (!inputAttribute.showSelectAll) {
            inputAttribute.childAttribute.forEach(childAttribute => {
              childAttribute.possibleValues.forEach(value => {
                if (value.selected) {
                  atleastOneSelected = true;
                }
              });
            });
          } else {
            inputAttribute.possibleValues.forEach(value => {
              if (value.selected) {
                atleastOneSelected = true;
                ifAdwordsAtLeastOne = true;
              }
            });
          }// changes

          // this block to detect and stye if replication field is validated or not

          // this block detects if atleast one checkbox is selected
          if (!atleastOneSelected) {
            atleastOneFromAllSelected = false;
          }
        }

        if (inputAttribute.type === 'FILE' && inputAttribute.required && !inputAttribute.fileName) {
          returnValue = false;
        }
      });

      if (checkBoxExists && !atleastOneFromAllSelected) {
        returnValue = false;
      }
      if (ifAdwordsAtLeastOne && this.selectedDatasource.type === 'ADWORDS') {
        returnValue = true;
      }

      // check if table name is valid for gaIntegration
      if (this.gaInputAttributes.length > 0) {
        this.gaInputAttributes.forEach((gaInputAttribute) => {
          const gaTableNameRegex = '^[a-zA-Z0-9]{1}(?!.*__)[a-zA-Z0-9_]{1,}[a-zA-Z0-9]{1}$';
          const regex = new RegExp(gaTableNameRegex);
          const gaTableName = gaInputAttribute.table;
          const regexVal = regex.exec(gaTableName);
          if (gaInputAttribute.table == null || gaInputAttribute.table === '' || regexVal == null) {
            returnValue = false;
          }
        });

      }
      if (this.gscInputAttributes.iterableData && this.gscInputAttributes.iterableData.length > 0) {
        this.gscInputAttributes.iterableData.forEach((gscInputAttribute) => {
          const gaTableNameRegex = '^[a-zA-Z0-9]{1}(?!.*__)[a-zA-Z0-9_]{1,}[a-zA-Z0-9]{1}$';
          const regex = new RegExp(gaTableNameRegex);
          const gaTableName = gscInputAttribute.table;
          const regexVal = regex.exec(gaTableName);
          if (gscInputAttribute.table == null || gscInputAttribute.table === '' || regexVal == null) {
            returnValue = false;
          }
        });

      }
      // if (checkBoxExists) {
      //   return atleastOneFromAllSelected;
      // }
      // return (checkBoxExists) ? (atleastOneFromAllSelected) : true;
      return returnValue;
    }*/

  copyToClipBoard(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  checkInputAttributeValid(inputAttribute: InputAttribute) {// console.log(this.checkChildAttributeValidity(inputAttribute))
    return !!(this.checkAttributeValidity(inputAttribute) && this.checkChildAttributeValidity(inputAttribute));
  }

  checkAttributeValidity(inputAttribute: InputAttribute) {
    // console.log(this.selectionKey(inputAttribute),this.currentSelection[this.selectionKey(inputAttribute)],
    // this.currentSelection[this.selectionKey(inputAttribute)])
    if (inputAttribute.type === 'EXPANDABLE') {
      let return_value = true;
      inputAttribute.childAttribute.forEach(childAttribute => {
        if (typeof this.currentSelection[this.selectionKey(childAttribute)] === 'undefined') {
          return_value = false;
        }
        if (typeof this.currentSelection[this.selectionKey(childAttribute)] !== 'undefined' &&
          this.currentSelection[this.selectionKey(childAttribute)].length === 0) {
          return_value = false;
        }

      });
      return return_value;
    } else {
      return typeof this.currentSelection[this.selectionKey(inputAttribute)] !== 'undefined' &&
        this.currentSelection[this.selectionKey(inputAttribute)].length > 0;
    }
  }

  checkChildAttributeValidity(inputAttribute: InputAttribute) {
    let return_value = false;
    if (inputAttribute.pivot || !inputAttribute.showSelectAll) {
      inputAttribute.childAttribute.forEach(childAttribute => {
        if (typeof this.currentSelection[this.selectionKey(childAttribute)] !== 'undefined' &&
          this.currentSelection[this.selectionKey(childAttribute)].length > 0) {
          return_value = true;
        }
      });
      return return_value;
    } else {
      return true;
    }
  }

  onCustomAliasChange(element: InputAttribute, childAttribute: InputAttribute[]) {
    this.userInputChanged = true;
    this.currentSelection[this.selectionKey(element) + '.customColumnAlias'] = [element.customColumnAlias];
    this.allCustomColumnsFilled = element.customColumnAlias.trim() !== '';
    // this.customTableDataSource.next(childAttribute);
  }

  onCustomDataTypeChange(element: InputAttribute, childAttribute: InputAttribute[]) {
    this.userInputChanged = true;
    this.currentSelection[this.selectionKey(element) + '.customColumnUserDefined'] = [element.customColumnUserDefined];
    // this.customTableDataSource.next(childAttribute);
  }

  /*getCustomTableSource(inputAttribute: InputAttribute) {
    return inputAttribute.childAttribute;
  }*/

  /*newlyAdded(inputAttribute: InputAttribute) {
    const selectionKey = this.selectionKey(inputAttribute.childAttribute);
    return (typeof this.dbIntegrationConfig[this.currentStep].selection[selectionKey] !== 'undefined');
  }*/

  refresh() {
    // this.myService.doSomething().subscribe((data: InputAttribute[]) => {
    //   this.customTableDataSource.data = data;
    // }
  }

  addCustomColumn(inputAttribute: InputAttribute) {
    let allColumnsMinDataFilled = true;
    inputAttribute.childAttribute.forEach(customColumn => {
      if (customColumn.editCustomColumn && (customColumn.customColumnAlias.trim() === '')) {
        allColumnsMinDataFilled = false;
      }
    });
    if (allColumnsMinDataFilled) {
      const newChildAttribute = new InputAttribute();
      newChildAttribute.possibleValues = this.possibleChildrenValues();
      const currentUnixStamp = (+moment()).toString();
      newChildAttribute.name = currentUnixStamp;
      newChildAttribute.label = currentUnixStamp;
      newChildAttribute.customColumnAlias = '';
      newChildAttribute.customColumnDefaultType = 'NUMERIC';
      newChildAttribute.customColumnUserDefined = 'NUMERIC';
      newChildAttribute.editCustomColumn = true;
      inputAttribute.childAttribute.push(newChildAttribute);
      this.currentSelection[this.selectionKey(newChildAttribute) + '.customColumnName'] = [newChildAttribute.name];
      this.currentSelection[this.selectionKey(newChildAttribute) + '.customColumnAlias'] = [''];
      this.currentSelection[this.selectionKey(newChildAttribute) + '.customColumnUserDefined'] =
        [newChildAttribute.customColumnUserDefined];
      this.customTableDataSource.next(inputAttribute.childAttribute);
      this.allCustomColumnsFilled = false;
      this.newlyAddedAttributes.push(newChildAttribute);
      this.customTable.nativeElement.scrollTop = this.customTable.nativeElement.scrollHeight;
    } else {
      window.alert('Please fill already added columns to create a new column');
    }
  }

  possibleChildrenValues() {
    const customColumnPossibleValues = [];
    for (let i = 0; i < 3; i++) {
      let value = '';
      switch (i) {
        case 0:
          value = 'NUMERIC';
          break;
        case 1:
          value = 'STRING';
          break;
        case 2:
          value = 'TIMESTAMP';
          break;
      }
      const customColumnPossibleValue = new GroupId();
      customColumnPossibleValue.value = value;
      customColumnPossibleValue.group = value;
      customColumnPossibleValues.push(customColumnPossibleValue);
    }
    return customColumnPossibleValues;
  }

  refreshCustomTable(childAttribute: InputAttribute[]) {
    return childAttribute;
  }


  getGAInputAttributes(inputAttributes: InputAttribute[]) {
    const gaAttributes: GAInputAttribute[] = [];
    const index = 0;
    const gaAttribute = new GAInputAttribute();
    inputAttributes.forEach(function (inputAttribute) {
      if (inputAttribute.label === 'Table') {
        gaAttribute.tableName = inputAttribute;
        gaAttribute.index = index;
      } else if (inputAttribute.label === 'Metrics') {
        gaAttribute.metrics = inputAttribute;
      } else if (inputAttribute.label === 'Dimensions') {
        gaAttribute.dimensions = inputAttribute;
      }
    });
    if (gaAttribute && Object.keys(gaAttribute).length > 0) {
      if (!this.editSourceBoolean) {
        gaAttribute.index = 0;
        gaAttribute.metricselectedList = [];
        gaAttribute.dimensionselectedList = [];
        gaAttribute.created = true;
        gaAttributes.push(gaAttribute);
        this.inputAttributes = [];
      } else {
        const selectTables = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.table';
        this.currentSelection = this.integrationConfig[this.currentStep].selection;
        for (const i of Object.keys(this.currentSelection[selectTables])) {
          const gaAtt = new GAInputAttribute();
          gaAtt.metrics = gaAttribute.metrics;
          gaAtt.dimensions = gaAttribute.dimensions;
          gaAtt.created = false;
          const table = this.currentSelection[selectTables][i];
          gaAttribute.tableName.value = table;
          gaAtt.tableName = { ...gaAttribute.tableName };
          const selectedeminsions = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + table + '.dimensions';
          const selectedmetrics = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + table + '.metrics';
          gaAtt.metricselectedList = this.currentSelection[selectedmetrics];
          gaAtt.dimensionselectedList = this.currentSelection[selectedeminsions];
          gaAtt.table = table;
          gaAtt.index = parseInt(i, 10);
          gaAttributes.push(gaAtt);
        }
        this.inputAttributes = [];
      }
    }
    return gaAttributes;
  }

  getGSCInputAttributes(inputAttributes: InputAttribute[]) {
    const gscAttributes = new GSCInputAttributes();
    const index = 0;
    const iterableAttribute = new CustomIterable();
    const iterableAttributes: CustomIterable[] = [];
    inputAttributes.forEach(function (inputAttribute) {
      if (inputAttribute.label === 'Tables') {
        gscAttributes.tableCheck = inputAttribute;
      } else if (inputAttribute.label === 'Search Analytics Table') {
        iterableAttribute.tableName = inputAttribute;
      } else if (inputAttribute.label === 'Your Dimensions') {
        iterableAttribute.dimensions = inputAttribute;
      }
    });

    if (gscAttributes && Object.keys(gscAttributes).length > 0) {
      if (!this.editSourceBoolean) {
        // gscAttribute.index = 0;
        //   iterableAttribute.tableNameList = [];
        iterableAttribute.dimensionselectedList = [];
        iterableAttribute.index = index;
        iterableAttribute.created = true;
        iterableAttributes.push(iterableAttribute);
        gscAttributes.iterableData = iterableAttributes;
        this.inputAttributes = [];

      }
    }

    return gscAttributes;

  }

  disableAllFilter(inputAttribute: InputAttribute, childAttribute: InputAttribute) {
    if (childAttribute.required) {
      childAttribute.required = !childAttribute.required;
    } else {
      childAttribute.selected = !childAttribute.selected;
    }
  }

  checkIfreportDimension(inputAttribute: InputAttribute) {
    return inputAttribute.childAttribute.find(c => c.name === 'report_dimension').selected;
  }

  getSnapchatAdsInputAttributes(inputAttributes: InputAttribute[]) {
    const snapAdsInputAttributes = [];
    const scAttribute = new SnapAdsInputAttribute();
    inputAttributes.forEach(inputAttribute => {
      if (inputAttribute.label === 'Table and Reports') {
        scAttribute.tableName = inputAttribute;
        snapAdsInputAttributes.push(scAttribute);
      }
    });
    this.inputAttributes = [];
    return snapAdsInputAttributes;
  }

  getHighestIndex(gaAttributes: GAInputAttribute[]): number {
    let index = 0;
    gaAttributes.forEach(value => {
      if (value.index > index) {
        index = value.index;
      }
    });
    return index;
  }

  addFreshchatAttribute(inputAttribute, index) {

    inputAttribute.ifAddButton = false;
    inputAttribute.ifRemoveButton = true;
    if (inputAttribute.name === 'instantmetrics') {

      const freshChatName = { ...this.inputAttributes[(index - 1)] };
      freshChatName.value = '';
      freshChatName.attrInputIndex = (this.inputAttributes[(index - 1)].attrInputIndex + 1);
      this.inputAttributes.push(freshChatName);
      const instantMetrics = { ...inputAttribute };
      instantMetrics.selectedList = [];
      instantMetrics.ifAddButton = true;
      instantMetrics.ifRemoveButton = true;
      instantMetrics.attrInputIndex = (this.inputAttributes[(index - 1)].attrInputIndex + 1);
      this.inputAttributes.push(instantMetrics);

    } else if (inputAttribute.name === 'historicalmetrics') {

      const freshChatName = { ...this.inputAttributes[(index - 1)] };
      freshChatName.value = '';
      freshChatName.attrInputIndex = (this.inputAttributes[(index - 1)].attrInputIndex + 1);
      this.inputAttributes.splice((index + 1), 0, freshChatName);
      const historicalmetrics = { ...inputAttribute };
      historicalmetrics.selectedList = [];
      historicalmetrics.ifAddButton = true;
      historicalmetrics.ifRemoveButton = true;
      historicalmetrics.attrInputIndex = (this.inputAttributes[(index - 1)].attrInputIndex + 1);
      this.inputAttributes.splice((index + 2), 0, historicalmetrics);
      // this.inputAttributes.push(historicalmetrics);

    }

  }

  removeFreshchatAttribute(inputAttribute, index) {
    const type = inputAttribute.name;
    let historicalMetricsIndex = 0;
    let instantMetricsIndex = 0;

    this.inputAttributes.forEach(i => {
      if (i.name === 'historicalmetrics') {
        historicalMetricsIndex++;
      }
      if (i.name === 'instantmetrics') {
        instantMetricsIndex++;
      }
    });

    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + this.inputAttributes[index - 1].value
      + '.' + inputAttribute.name;
    delete this.currentSelection[selectedKey];

    if (historicalMetricsIndex === 2 && type === 'historicalmetrics') {
      this.inputAttributes.splice((index - 1), 2);
      this.inputAttributes[2].ifRemoveButton = false;
      this.inputAttributes[2].ifAddButton = true;

    } else if (instantMetricsIndex === 2 && type === 'instantmetrics') {
      this.inputAttributes.splice((index - 1), 2);
      this.inputAttributes[(this.inputAttributes.length - 1)].ifRemoveButton = false;
      this.inputAttributes[(this.inputAttributes.length - 1)].ifAddButton = true;

    } else {
      this.inputAttributes.splice((index - 1), 2);
    }


    if (inputAttribute.name === 'historicalmetrics') {
      const selectedKey1 = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.historicaltables';
      this.currentSelection[selectedKey1].splice(inputAttribute.attrInputIndex, 1);
    } else if (inputAttribute.name === 'instantmetrics') {
      const selectedKey1 = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.instanttables';
      this.currentSelection[selectedKey1].splice(inputAttribute.attrInputIndex, 1);

    }
    // this.currentSelection[this.selectionKey(inputAttribute)] = undefined //[inputAttribute.value]
    // this.currentSelection[this.selectionKey(inputAttribute)].splice(2, 1)
  }

  addGaAttribute(gaAttribute: GAInputAttribute) {
    const ga = new GAInputAttribute();
    ga.tableName = { ...gaAttribute.tableName };
    ga.metrics = { ...gaAttribute.metrics };
    ga.dimensions = { ...gaAttribute.dimensions };
    ga.dimensionselectedList = [];
    ga.metricselectedList = [];
    ga.created = true;
    ga.tableName.value = '';
    let index = 0;
    this.gaInputAttributes.forEach(value => {
      if (value.index > index) {
        index = value.index;
      }
    });
    ga.index = index + 1;
    this.gaInputAttributes.push(ga);
  }

  addGscAttribute(gscAttribute: CustomIterable) {
    const gsc = new CustomIterable();
    gsc.tableName = { ...gscAttribute.tableName };
    // ga.metrics = gaAttribute.metrics;
    gsc.dimensions = { ...gscAttribute.dimensions };
    gsc.dimensionselectedList = [];
    //    ga.metricselectedList = [];
    gsc.created = true;
    let index = 0;
    this.gscInputAttributes.iterableData.forEach(value => {
      if (value.index > index) {
        index = value.index;
      }
    });
    gsc.index = index + 1;
    this.gscInputAttributes.iterableData.push(gsc);

  }


  removeGaAttribute(gaInputAttribute: GAInputAttribute) {
    if (this.gaInputAttributes.length > 1) {
      if (this.currentSelection[this.selectionKey(gaInputAttribute.tableName)]) {
        const d = this.currentSelection[this.selectionKey(gaInputAttribute.tableName)];
        if (d.indexOf(gaInputAttribute.table) !== -1) {
          this.currentSelection[this.selectionKey(gaInputAttribute.tableName)] =
            this.currentSelection[this.selectionKey(gaInputAttribute.tableName)].filter(item => item !== gaInputAttribute.table);
        }
        const selectedKey1 = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + gaInputAttribute.table
          + '.' + gaInputAttribute.dimensions.name;
        const selectedKey2 = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + gaInputAttribute.table
          + '.' + gaInputAttribute.metrics.name;
        delete this.currentSelection[selectedKey1];
        delete this.currentSelection[selectedKey2];
      }

      this.gaInputAttributes.filter((value, index) => {
        if (value.index === gaInputAttribute.index) {
          this.gaInputAttributes.splice(index, 1);
        }
      });
    }
    this.reloadContent();
  }

  removeGscAttribute(gscInputAttribute: CustomIterable) {

    if (this.gscInputAttributes.iterableData.length > 1) {
      if (this.currentSelection[this.selectionKey(gscInputAttribute.tableName)]) {
        const d = this.currentSelection[this.selectionKey(gscInputAttribute.tableName)];
        if (d.indexOf(gscInputAttribute.table) !== -1) {
          this.currentSelection[this.selectionKey(gscInputAttribute.tableName)] =
            this.currentSelection[this.selectionKey(gscInputAttribute.tableName)].filter(item => item !== gscInputAttribute.table);
        }
        const selectedKey1 = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + gscInputAttribute.tableName.value
          + '.' + gscInputAttribute.dimensions.name;

        delete this.currentSelection[selectedKey1];
      }

      this.gscInputAttributes.iterableData.filter((value, index) => {
        if (value.index === gscInputAttribute.index) {
          this.gscInputAttributes.iterableData.splice(index, 1);
        }
      });
    }
    this.reloadContent();

  }

  onChangeInGaTableValue(gaInputAttribute: GAInputAttribute, inputAttribute: InputAttribute) {
    // const _oldNameHolder = inputAttribute.value;
    inputAttribute.value = gaInputAttribute.table;
    gaInputAttribute.tableName = inputAttribute;
    this.validateTableNames(inputAttribute);
    //  Object.keys(this.currentSelection).forEach((ele)=> {
    //   console.log(typeof ele,ele,inputAttribute.value)
    //   if (_oldNameHolder !== '' && ele.includes(_oldNameHolder)) {
    //     const _valueHolder = this.currentSelection[ele]
    //     const _newKey = ele.replace(_oldNameHolder,gaInputAttribute.table)
    //     delete this.currentSelection[ele]
    //     this.currentSelection[_newKey] = _valueHolder
    //   }

    // })

    // if (_oldNameHolder !== '') {
    //   const index = this.currentSelection[this.selectedDatasource.type + '.input.'+(this.currentStep + 1)+'.table'].findIndex((ele)=>
    //   ele === _oldNameHolder )
    //   this.currentSelection[this.selectedDatasource.type + '.input.'+(this.currentStep + 1)+'.table'][index] = gaInputAttribute.table

    // }

  }

  onChangeInGscTableValue(gscInputAttribute: CustomIterable, inputAttribute: InputAttribute) {
    // const _oldNameHolder = inputAttribute.value;
    inputAttribute.value = gscInputAttribute.table;
    gscInputAttribute.tableName = inputAttribute;
    this.validateGSCTableNames(inputAttribute);


    if (gscInputAttribute.index === 0) {


      if (!this.gscTableLock && !this.gscTables.length && !(Object.keys(this.currentSelection).length === 0
        && this.currentSelection.constructor === Object)) {

        this.gscTables = this.currentSelection[this.selectionKey(gscInputAttribute.tableName)];
        this.gscTables.push(this.selectionKey(gscInputAttribute.tableName));

      }

      this.currentSelection[this.selectionKey(gscInputAttribute.tableName)] = [gscInputAttribute.table];
      this.gscTableLock = true;

    } else {

      this.currentSelection[this.selectionKey(gscInputAttribute.tableName)][gscInputAttribute.index] = gscInputAttribute.table;
    }

    // Object.keys(this.currentSelection).forEach((ele)=> {
    //   console.log(typeof ele,ele,inputAttribute.value)
    //   if (_oldNameHolder !== '' && ele.includes(_oldNameHolder)) {
    //     const _valueHolder = this.currentSelection[ele]
    //     const _newKey = ele.replace(_oldNameHolder,gscInputAttribute.table)
    //     delete this.currentSelection[ele]
    //     this.currentSelection[_newKey] = _valueHolder
    //   }

    // })

    // if (_oldNameHolder !== '') {
    //   const index = this.currentSelection[this.selectedDatasource.type + '.input.'+(this.currentStep + 1)+'.table'].findIndex((ele)=>
    //   ele === _oldNameHolder )
    //   this.currentSelection[this.selectedDatasource.type + '.input.'+(this.currentStep + 1)+'.table'][index] = gscInputAttribute.table

    // }
  }

  validateGSCTableNames(inputAttribute: GAInputAttribute) {
    const seletedTable = [];
    for (const gscInputAttribute of this.gscInputAttributes.iterableData) {
      if (seletedTable.includes(gscInputAttribute.table)) {
        gscInputAttribute.errorMessage = 'duplicate table name';
        this.sametableName = true;
      } else {
        seletedTable.push(gscInputAttribute.table);
        gscInputAttribute.errorMessage = '';
        this.sametableName = false;
      }
    }

  }

  validateTableNames(inputAttribute: GAInputAttribute) {
    const selectedTable = [];
    for (const gaInputAttribute of this.gaInputAttributes) {
      if (selectedTable.includes(gaInputAttribute.table)) {
        gaInputAttribute.errorMessage = 'duplicate table name';
        this.sametableName = true;
      } else {
        selectedTable.push(gaInputAttribute.table);
        gaInputAttribute.errorMessage = '';
        this.sametableName = false;
      }
    }
  }

  clearGaTableAttributes(value: any, gaInputAttribute: GAInputAttribute, inputAttribute: InputAttribute, tableName: string) {
    if (this.currentSelection[this.selectionKey(gaInputAttribute.tableName)]) {
      const d = this.currentSelection[this.selectionKey(gaInputAttribute.tableName)];
      if (d.indexOf(gaInputAttribute.table) === -1) {
        this.currentSelection[this.selectionKey(gaInputAttribute.tableName)] = [];
      }
    } else {
      this.currentSelection[this.selectionKey(gaInputAttribute.tableName)] = [];
    }
    if (inputAttribute.name === 'dimensions') {
      gaInputAttribute.dimensionselectedList = [];
    } else if (inputAttribute.name === 'metrics') {
      gaInputAttribute.metricselectedList = [];
    }
    this.userInputChanged = true;
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + inputAttribute.name;
    if (this.currentSelection[selectedKey]) {
      this.currentSelection[selectedKey] = [];
    } else {
      this.currentSelection[selectedKey] = [];
    }
  }

  clearGscTableAttributes(value: any, gscInputAttribute: CustomIterable, inputAttribute: InputAttribute, tableName: string) {

    if (this.currentSelection[this.selectionKey(gscInputAttribute.tableName)]) {
      const d = this.currentSelection[this.selectionKey(gscInputAttribute.tableName)];
      if (d.indexOf(gscInputAttribute.table) === -1) {
        this.currentSelection[this.selectionKey(gscInputAttribute.tableName)] = [];
      }
    } else {
      this.currentSelection[this.selectionKey(gscInputAttribute.tableName)] = [];
    }
    if (inputAttribute.name === 'dimensions') {
      gscInputAttribute.dimensionselectedList = [];
    }
    this.userInputChanged = true;
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + inputAttribute.name;
    if (this.currentSelection[selectedKey]) {
      this.currentSelection[selectedKey] = [];
    } else {
      this.currentSelection[selectedKey] = [];
    }
  }

  onGaTableAttributeValue(value: any, gaInputAttribute: GAInputAttribute, inputAttribute: InputAttribute, tableName: string) {
    if (this.currentSelection[this.selectionKey(gaInputAttribute.tableName)]) {
      const d = this.currentSelection[this.selectionKey(gaInputAttribute.tableName)];
      if (d.indexOf(gaInputAttribute.table) === -1) {
        this.currentSelection[this.selectionKey(gaInputAttribute.tableName)].push(gaInputAttribute.table);
      }
    } else {
      this.currentSelection[this.selectionKey(gaInputAttribute.tableName)] = [gaInputAttribute.table];
    }
    if (inputAttribute.name === 'dimensions') {
      gaInputAttribute.dimensionselectedList.push(value.value.toString());
    } else if (inputAttribute.name === 'metrics') {
      gaInputAttribute.metricselectedList.push(value.value.toString());
    }
    this.userInputChanged = true;
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + inputAttribute.name;
    if (this.currentSelection[selectedKey]) {
      if (!this.currentSelection[selectedKey].includes(value.value.toString())) {
        this.currentSelection[selectedKey].push(value.value.toString());
      }
    } else {
      this.currentSelection[selectedKey] = [value.value.toString()];
    }
    if (this.editSourceBoolean && this.editedTablesGA.indexOf(gaInputAttribute.table) === -1) {
      this.alertDataDropGA(gaInputAttribute, value, inputAttribute);
      // this.editedTables.push(gaInputAttribute.table);
    }
  }

  onGscTableAttributeValue(value: any, gscInputAttribute: CustomIterable, inputAttribute: InputAttribute, tableName: string) {
    if (this.currentSelection[this.selectionKey(gscInputAttribute.tableName)]) {
      const d = this.currentSelection[this.selectionKey(gscInputAttribute.tableName)];
      if (d.indexOf(gscInputAttribute.table) === -1) {
        this.currentSelection[this.selectionKey(gscInputAttribute.tableName)].push(gscInputAttribute.table);
      }
    } else {
      this.currentSelection[this.selectionKey(gscInputAttribute.tableName)] = [gscInputAttribute.table];
    }
    if (inputAttribute.name === 'dimension') {
      gscInputAttribute.dimensionselectedList.push(value.value.toString());
    }
    this.userInputChanged = true;
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + inputAttribute.name;
    if (this.currentSelection[selectedKey]) {
      if (!this.currentSelection[selectedKey].includes(value.value.toString())) {
        this.currentSelection[selectedKey].push(value.value.toString());
      }
    } else {
      this.currentSelection[selectedKey] = [value.value.toString()];
    }
  }

  removeGaTableAttributeValues(value: any, gaInputAttribute: GAInputAttribute, inputAttribute: InputAttribute, tableName: string,
    codeGenCall = false) {
    this.userInputChanged = true;
    if (inputAttribute.name === 'dimensions') {
      gaInputAttribute.dimensionselectedList = gaInputAttribute.dimensionselectedList.filter(item => item !== value.label);
    } else if (inputAttribute.name === 'metrics') {
      gaInputAttribute.metricselectedList = gaInputAttribute.metricselectedList.filter(item => item !== value.label);
    }
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + inputAttribute.name;
    if (this.currentSelection[selectedKey]) {
      this.currentSelection[selectedKey] = this.currentSelection[selectedKey].filter(item => item !== value.label);
    } else {
      this.currentSelection[selectedKey] = [];
    }
    if (!codeGenCall && (this.editSourceBoolean && this.editedTables.indexOf(gaInputAttribute.table) === -1)) {
      this.editedTables.push(gaInputAttribute.table);
    }
  }

  removeGscTableAttributeValues(value: any, gaInputAttribute: CustomIterable, inputAttribute: InputAttribute, tableName: string) {

    this.userInputChanged = true;
    if (inputAttribute.name === 'dimensions') {
      gaInputAttribute.dimensionselectedList = gaInputAttribute.dimensionselectedList.filter(item => item !== value.label);
    }
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + inputAttribute.name;
    if (this.currentSelection[selectedKey]) {
      this.currentSelection[selectedKey] = this.currentSelection[selectedKey].filter(item => item !== value.label);
    } else {
      this.currentSelection[selectedKey] = [];
    }
  }

  onsnapchatadsTableAttributeValue(value: any, childAttribute: InputAttribute, tableName: string) {
    this.userInputChanged = true;
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + childAttribute.name;
    if (this.currentSelection[selectedKey]) {
      if (!this.currentSelection[selectedKey].includes(value.value)) {
        this.currentSelection[selectedKey].push(value.value);
      }
    } else {
      this.currentSelection[selectedKey] = [value.value];
    }
  }

  removesnapchatTableAttributeValues(value: any, childAttribute: InputAttribute, tableName: string) {

    this.userInputChanged = true;
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + childAttribute.name;
    if (this.currentSelection[selectedKey]) {
      this.currentSelection[selectedKey] = this.currentSelection[selectedKey].filter(item => item !== value.label);
    } else {
      this.currentSelection[selectedKey] = [];
    }
  }

  clearSnapchatadsTableAttributes(value: any, childAttribute: InputAttribute, tableName: string) {
    childAttribute.selectedList = [];
    const selectedKey = this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' + tableName + '.' + childAttribute.name;
    if (this.currentSelection[selectedKey]) {
      this.currentSelection[selectedKey] = [];
    } else {
      this.currentSelection[selectedKey] = [];
    }
  }

  private addHidden(inputAttributes: InputAttribute[]) {
    inputAttributes.filter((v, i, a) => v.type === 'HIDDEN' || v.type === 'CLIPBOARD')
      .forEach((v, i, a) => this.currentSelection[this.selectionKey(v)] = [v.value]);
  }

  private selectionKey(inputAttribute: InputAttribute): string {
    if (this.datasourceBoolean) {
      return this.selectedDatasource.type + '.input.' + (this.currentStep + 1) + '.' +
        inputAttribute.name;
    } else {
      return this.selectedDatawarehouse.type + '.input.' + (this.currentStep + 1) + '.' +
        inputAttribute.name;
    }
  }

  private pushData(selectionKey: string, value: GroupId) {
    value.data.forEach((v, i, a) => {
      const dataKey = selectionKey + '.' + value.value + '.' + v.name;
      if (!this.currentSelection[dataKey]) {
        this.currentSelection[dataKey] = [];
      }
      this.currentSelection[dataKey].push(v.value);
    });
  }

  private deleteData(selectionKey: string, value: GroupId) {
    value.data.forEach((v, i, a) => {
      const dataKey = selectionKey + '.' + value.value + '.' + v.name;
      if (this.currentSelection[dataKey]) {
        this.currentSelection[dataKey]
          .splice(this.currentSelection[dataKey].indexOf(value.value), 1);
        if (this.currentSelection[dataKey].length === 0) {
          delete this.currentSelection[dataKey];
        }
      }
    });
  }

  private getPath(): string {
    if (this.editWarehouseBoolean && this.currentSelection['path']) {
      return this.currentSelection['path'][0]

    }
    let inputAttrObjectKey = this.inputAttributes.find(inputAttr => inputAttr.name === 'keyPrefix')
    let inputAttrObjectFormat = this.inputAttributes.find(inputAttr => inputAttr.name === 'optionalKeyElements')
    let objectKeyPrefix = this.integrationConfig[1].selection[`${this.selectedDatawarehouse.type}.input.2.keyPrefix`][0]
    let returnString = objectKeyPrefix + '/integrationName/tableName/'
    let keyEle = ''
    //returnString = 'integrationName/tableName/'this.integrationConfig[this.currentStep -1 ].selection
    if (this.integrationConfig[this.currentStep - 1].selection.hasOwnProperty('GCS.input.2.keyPrefix')) {
      returnString += this.integrationConfig[this.currentStep - 1].selection[this.selectedDatawarehouse.type + '.input.' + this.currentStep + '.keyPrefix'][0] + '/'
    } else if (inputAttrObjectKey !== undefined && this.currentSelection[this.selectionKey(inputAttrObjectKey)] && this.currentSelection[this.selectionKey(inputAttrObjectKey)][0]) {
      returnString += this.currentSelection[this.selectionKey(inputAttrObjectKey)][0] + '/'
    }
    if (this.currentSelection[this.selectionKey(inputAttrObjectFormat)] && this.currentSelection[this.selectionKey(inputAttrObjectFormat)][0]) {
      //console.log(this.currentSelection[this.selectionKey(inputAttrObjectFormat)])
      this.currentSelection[this.selectionKey(inputAttrObjectFormat)].sort((a, b) => {
        return this.order[a] - this.order[b];
      });
      //console.log(this.currentSelection[this.selectionKey(inputAttrObjectFormat)])
      this.currentSelection[this.selectionKey(inputAttrObjectFormat)].forEach(value => {
        switch (value) {
          case 'Day': keyEle = keyEle + (new Date().getDate().toString().length === 2 ? new Date().getDate() : '0' + new Date().getDate()) + '/'; break
          case 'Month': keyEle = keyEle + ((new Date().getMonth() + 1).toString().length === 2 ? new Date().getMonth() + 1 : '0' + (new Date().getMonth() + 1)) + '/'; break
          case 'Year': keyEle = keyEle + new Date().getFullYear() + '/'; break
          case 'Hour': keyEle = keyEle + (new Date().getHours().toString().length === 2 ? new Date().getHours() : '0' + new Date().getHours()) + '/'; break
        }
      })
      returnString += keyEle
    }
    if (returnString !== 'integrationName/tableName/') {
      this.currentSelection['path'] = [returnString]
    }

    return returnString
  }

}
